/* eslint-disable object-curly-newline */
import moment from "moment";
import { store } from '@common/store/store';
import { sDs } from '@common/sDs/sDs';
import { library } from "@common/library/library";
import { uStore } from "@common/userStore";
import localLayouts from "../devDash/data/localLayouts.json"; // this is for self-hosted clients, DO NOT REMOVE
import { recordSourceControl, createRecordSourceControl } from "./actionStore";
import { ddStore } from "@common/ddStore";

const projectAllowsCaching = typeof VUE_PROJECT_NAME !== 'undefined' && VUE_PROJECT_NAME === 'devDash';
/*
* vuex module for cfg.
* test in console: configStore.getAvailableFieldList(1).then(function (tmp) {console.log(tmp)}) // @phpstan-ignore-line
* */
const configStore = {
    namespaced: true,
    pspParentNames: {
        1: 'Volunteer',
        'vol': 'Volunteer',
        2: 'Opportunity',
        'opp': 'Opportunity',
        3: 'Organization',
        'org': 'Organization',
        'sch': 'Shift',
        5: 'Client',
        'cli': 'Client',
        'mem': 'Client',
        100: 'Account',
        'acc': 'Account',
        101: 'Coordinator User',
        'client': 'Coordinator User',
        14: 'Profession',
        'pro': 'Profession',
        8: 'Activity',
        'ae': 'Activity',
        'cre': 'Credential',
        'lbe': 'Logbook',
        'aff': 'Affiliation',
        'assignment': 'Assignment',
        32: 'Affiliation',
        33: 'Vol Affiliation',
        34: 'Org Affiliation',
        36: 'Vol Affiliation',
        105: 'Contact Record',
        'ctr': 'Contact Record',
    },
    pspParentNamesPlural: {
        1: 'Volunteers',
        'vol': 'Volunteers',
        2: 'Opportunities',
        'opp': 'Opportunities',
        3: 'Organizations',
        'org': 'Organizations',
        'sch': 'Shifts',
        5: 'Clients',
        'cli': 'Clients',
        8: 'Activities',
        'ae': 'Activities',
        100: 'Accounts',
        'acc': 'Accounts',
        101: 'Coordinator Users',
        'client': 'Coordinator Users',
        14: 'Professions',
        'pro': 'Professions',
        'cre': 'Credentials',
        'lbe': 'Logbooks',
        32: 'Affiliations',
        'aff': 'Affiliations',
        33: 'Vol Affiliations',
        34: 'Org Affiliations',
        105: 'Contact Records',
        'ctr': 'Contact Records',
    },
    pspParentNamesAbbrev: {
        1: 'vol',
        2: 'opp',
        3: 'org',
        5: 'mem',
        8: 'ae',
        11: 'sch',
        14: 'pro',
        100: 'acc',
        101: 'client',
        32: 'aff',
        105: 'ctr',
        'dashboard': 'dashboard'
    },
    pspIds: {
        'vol': 1,
        'opp': 2,
        'org': 3,
        'mem': 5,
        'ae': 8,
        'sch': 11,
        'pro': 14,
        'acc': 100,
        'client': 101,
        'aff': 32,
        'ctr': 105,
        'dashboard': 'dashboard'
    },
    state: {
        cfg: {
            currentDate: null,
            currentTime: null,
            currentYear: null,
            currentMonth: null,
            currentMonthName: null,
            currentWeekDay: null,
            currentWeekDayName: null,
            currentMonthDay: null,
            currentYearDay: null,
            currentTimeWithSeconds: null,
            currentDateTimeWithSeconds: null,
            unixDates: {},
            componentStylesheets: {},
            allFieldsListPspArray: ['vol', 'opp', 'org', 'sch', 'acc', 'lbe', 'pro', 'cre', 'ae', 'aff', 'client'],
            standardPalettes: [
                {
                    id: 'newPalette',
                    title: 'New Palette',
                    hasChild: false,
                    standard: true
                },
                {
                    id: 'standardPalettes',
                    title: 'Standard Palettes',
                    hasChild: true,
                    standard: true,
                    selectable: false,
                    htmlAttributes: { 'prevent-select': 'true' },
                },
                {
                    id: 'samaritanPalette',
                    title: 'Samaritan Palette (Extended)',
                    pId: 'standardPalettes',
                    standard: true,
                    colors: [
                        {
                            label: 'Samaritan Blue',
                            color: '#08538A'
                        },
                        {
                            label: 'Samaritan Aqua',
                            color: '#82CDD3'
                        },
                        {
                            label: 'Samaritan Yellow',
                            color: '#F8DE46'
                        },
                        {
                            label: 'Warm Gray Dark',
                            color: '#635D5C'
                        },
                        {
                            label: 'Warm Gray Light',
                            color: '#A6A2A0'
                        },
                        {
                            label: 'Red',
                            color: '#E54F4F'
                        },
                        {
                            label: 'Orange',
                            color: '#FF8C52'
                        },
                        {
                            label: 'Green',
                            color: '#5EB16E'
                        }
                    ]
                },
                {
                    id: 'samaritanGrays',
                    title: 'Samaritan Grays',
                    pId: 'standardPalettes',
                    standard: true,
                    colors: [
                        {
                            label: 'Dark Gray',
                            color: '#554B46'
                        },
                        {
                            label: 'Warm Gray Dark',
                            color: '#635D5C'
                        },
                        {
                            label: 'Warm Gray Dark 75%',
                            color: '#8A8685'
                        },
                        {
                            label: 'Warm Gray Light',
                            color: '#A6A2A0'
                        },
                        {
                            label: 'Warm Gray Light 25%',
                            color: '#E9E8E7'
                        },
                        {
                            label: 'Warm Gray Light 10%',
                            color: '#F6F6F6'
                        }
                    ]
                },
                {
                    id: 'brightAndFun',
                    title: 'Bright and Fun',
                    pId: 'standardPalettes',
                    standard: true,
                    colors: [
                        {
                            label: 'Pale Indigo',
                            color: '#444e86'
                        },
                        {
                            label: 'Spring Lilac',
                            color: '#955196'
                        },
                        {
                            label: 'Pretty Pink',
                            color: '#dd5182'
                        },
                        {
                            label: 'Creamsicle',
                            color: '#ff6e54'
                        },
                        {
                            label: 'Lemon Meringue',
                            color: '#ffa600'
                        },
                        {
                            label: 'Fresh Cut Grass',
                            color: '#7a9c3c'
                        },
                        {
                            label: 'Summer Sky',
                            color: '#2dc1db'
                        }
                    ]
                },
                {
                    id: 'mutedDarks',
                    title: 'Muted Darks',
                    pId: 'standardPalettes',
                    standard: true,
                    colors: [
                        {
                            label: 'Dark Indigo',
                            color: '#252e5c'
                        },
                        {
                            label: 'Purple Plum',
                            color: '#511c52'
                        },
                        {
                            label: 'Rose Red',
                            color: '#802344'
                        },
                        {
                            label: 'Sky on Fire',
                            color: '#a33927'
                        },
                        {
                            label: 'Bumble Bee',
                            color: '#bd820f'
                        },
                        {
                            label: 'Fresh Cut Grass',
                            color: '#445525'
                        },
                        {
                            label: 'Samaritan Blue',
                            color: '#08538a'
                        }
                    ]
                }
            ],
            customPalettes: null,
            folders: {
                '1': [],
                '2': [],
                '3': [],
                '5': [],
                '14': []
            }
        },
        dateTimeUpdateInterval: false,
        editorOptions: {
            attachTypeList: {}
        },
        dataAge: {},
        devDashInstanceDetails: false,
        devDashLocalInstanceDetails: false,
        canBeUsedAsItemsSource: [
            // 'getDatasetList',
            // 'getDatasourceList',
            // 'getDatasetDetails',
            'getDatasetColumnOptions',
            'pdfTemplateOptions',
            // 'allFieldsList',
            'allFieldOptions',
            'bcPackageOptions',
            'allVolOptions',
            'allOppOptions',
            'allOrgOptions',
            // 'getTemplateList',
            // 'getComponentList',
            // 'getAccountSettings',
            // 'getRecruiterSettings',
            // 'getSurveyList',
            // 'getBcPackageList',
            // 'getAutomationList',
            // 'getAllAutomationList',
            'allAutomationOptions',
            // 'getAvailableFieldList',
            // 'getAttrList'
            'getFieldConfig'
        ]
    },
    getters: {
        configStore(state) {
            return state.cfg;
        },
        paletteOptions(state) {
            if (Array.isArray(state.cfg.customPalettes)) return state.cfg.standardPalettes.concat(state.cfg.customPalettes);
            return state.cfg.standardPalettes;
        },
        getPaletteOptions(state) {
            return async function () {
                await configStore.getData({ kName: 'customPalettes', fName: 'ec_getCstProperty', useCaching: projectAllowsCaching, accountSpecific: true }, 'palettes');
                if (Array.isArray(state.cfg.customPalettes)) return state.cfg.standardPalettes.concat(state.cfg.customPalettes);
                return state.cfg.standardPalettes;
            };
        },
        getCurrentInstanceDetails(state) {
            return function (payload) {
                let [onlyValues] = Object.values(payload);
                let getParams = library.urlParser.getParams();
                let isLocalhost = typeof FROM_LOCALHOST !== 'undefined' ? FROM_LOCALHOST : false;
                let quicklink = typeof getParams['quicklink'] !== 'undefined' ? getParams['quicklink'] : '';
                let vueProjectName = typeof VUE_PROJECT_NAME !== 'undefined' ? VUE_PROJECT_NAME : 'vueBridge';
                let instanceName = typeof THE_CUSTOMER !== 'undefined' ? THE_CUSTOMER : '';
                let isProd = typeof getParams['isprod'] !== 'undefined' || window.location.search.indexOf('devdash.samaritan.com') > -1;
                let projectName = typeof PROJECT_NAME !== 'undefined' ? PROJECT_NAME : '';
                if (!instanceName && vueProjectName === 'devDash') {
                    instanceName = isProd ? 'DEVDASH' : 'DEVDASHQA';
                }
                let instanceDetails = {
                    isProd: {
                        label: 'Is Production Instance',
                        value: isProd,
                        type: 'boolean'
                    },
                    isLocalhost: {
                        label: 'Is From Localhost',
                        value: isLocalhost,
                        type: 'boolean'
                    },
                    quicklink: {
                        label: 'Quicklink',
                        value: quicklink,
                        type: 'string'
                    },
                    projectName: {
                        label: 'Project Name',
                        value: projectName,
                        type: 'string'
                    },
                    vueProjectName: {
                        label: 'Vue Project Name',
                        value: vueProjectName,
                        type: 'string'
                    },
                    instanceName: {
                        label: 'Instance Name',
                        value: instanceName,
                        type: 'string'
                    }
                };
                let result = instanceDetails;
                if (onlyValues) {
                    let tmpResult = {};
                    for (let i in result) {
                        tmpResult[i] = result[i].value;
                    }
                    result = tmpResult;
                }
                return result;
            };
        },
        getDevDashLocalInstanceDetails(state) {
            return async function (payload) {
                if (typeof VUE_PROJECT_NAME === 'undefined' || VUE_PROJECT_NAME !== 'devDash') {
                    return [];
                }
                let { refresh, addToSessionStorage } = payload[0] || {};
                let sessionData = library.getSessionStorage('devDashLocalInstanceDetails');
                if (sessionData) {
                    if (!state.cfg.devDashLocalInstanceDetails) state.cfg.devDashLocalInstanceDetails = JSON.parse(library.getSessionStorage('devDashLocalInstanceDetails'));
                    return state.cfg.devDashLocalInstanceDetails;
                }
                let responseData = await configStore.getData({ kName: 'devDashLocalInstanceDetails', fName: 'sds_getDevDashLocalInstanceDetails', refresh: refresh });
                if (addToSessionStorage) library.setSessionStorage('devDashLocalInstanceDetails', JSON.stringify(responseData));
                return state.cfg.devDashLocalInstanceDetails;
            };
        },
        getDevDashStateCrcParams(state) {
            return async function (payload) {
                let [crc, instance, refresh] = Object.values(payload);
                let loggedUsers = await uStore().getLoggedUsers();
                let useCaching = projectAllowsCaching && loggedUsers.user;
                let result = await configStore.getData(
                    {
                        kName: 'devDashStateCrcParams',
                        fName: 'sds_getDevDashStateCrcParams',
                        subKey: crc,
                        additionalSubKey: instance,
                        storeKey: library.getSessionStorage('devDashEnv') + '/sds_getDevDashStateCrcParams',
                        refresh: refresh,
                        useCaching: useCaching
                    }
                );
                if (!loggedUsers.user) {
                    if (instance) {
                        delete state.cfg.devDashStateCrcParams[crc][instance];
                    } else {
                        delete state.cfg.devDashStateCrcParams[crc];
                    }
                }
                return result;
            };
        },
        getDatasetList() {
            return async function (payload) {
                let [refresh, datasetIds] = Object.values(payload);
                let mergeData = !!datasetIds;
                let mergePrimaryKey = datasetIds ? 'dsId' : false;
                if (mergeData) {
                    return configStore.getData({ kName: 'datasetList', fName: 'sds_getDatasetList', storeKey: library.getSessionStorage('devDashEnv') + '/sds_getDatasetList', refresh: refresh, useCaching: projectAllowsCaching, mergeData: mergeData, mergePrimaryKey: mergePrimaryKey }, datasetIds);
                }
                return configStore.getData({ kName: 'datasetList', fName: 'sds_getDatasetList', storeKey: library.getSessionStorage('devDashEnv') + '/sds_getDatasetList', refresh: refresh, useCaching: projectAllowsCaching });
            };
        },
        getAllSourceList(state) {
            return async function () {
                let dataSources = await configStore.getDatasourceList();
                let itemsSources = await configStore.itemsSourceOptions();
                return [...dataSources, ...itemsSources];
            };
        },
        getsDsList(state) {
            return function () {
                return [
                    {
                        text: 'sDs Requests',
                        value: 'sds',
                        hasChild: true,
                        selectable: false,
                        htmlAttributes: { 'prevent-select': 'true' },
                    },
                    {
                        text: 'Recruiter Cst Property',
                        value: 'er_getCstProperty',
                        type: 'sds',
                        pId: 'sds',
                        updateFrequency: 0,
                        params: {
                            cstProperty: {
                                label: 'CST Key to Access',
                                type: 'string',
                                id: 'cstProperty',
                                helpText: 'Which CST key are you trying to access for your data source? Note: this is the first param in the er_getCstProperty sDs function.',
                                paramIndex: 0
                            },
                            subKey: {
                                label: 'Sub Key',
                                type: 'string',
                                id: 'subKey',
                                helpText: 'If there is a sub-key in the response, what key do you want to use?',
                            },
                            fromDevDash: {
                                id: 'fromDevDash',
                                default: false,
                                display: false,
                                paramIndex: 1
                            },
                            useLoggedUserInstance: {
                                id: 'useLoggedUserInstance',
                                default: true,
                                display: false,
                                paramIndex: 2
                            }
                        }
                    },
                    {
                        text: 'Coordinator Cst Property',
                        value: 'ec_getCstProperty',
                        type: 'sds',
                        pId: 'sds',
                        updateFrequency: 0,
                        params: {
                            cstProperty: {
                                label: 'CST Key to Access',
                                type: 'string',
                                id: 'cstProperty',
                                helpText: 'Which CST key are you trying to access for your data source? Note: this is the first param in the er_getCstProperty sDs function.'
                            },
                            subKey: {
                                label: 'Sub Key',
                                type: 'string',
                                id: 'subKey',
                                helpText: 'If there is a sub-key in the response, what key do you want to use?'
                            },
                            fromDevDash: {
                                id: 'fromDevDash',
                                default: false,
                                display: false
                            },
                            useLoggedUserInstance: {
                                id: 'useLoggedUserInstance',
                                default: true,
                                display: false
                            }
                        }
                    },
                    {
                        text: 'Get eC User Roles',
                        value: 'ec_getRoles',
                        type: 'sds',
                        pId: 'sds',
                        addParamsIndex: 1,
                        params: {
                            onlyAssigned: {
                                type: 'boolean',
                                display: true,
                                default: true,
                                paramIndex: 0
                            },
                        }
                    },
                    {
                        text: 'Affiliation List',
                        value: 'sds_getAffiliationList',
                        type: 'sds',
                        // Params are configs for controls that are displayed to provide the params of the sDs call.
                        // They will be used by the checkParams function from the actionStore which displays a dialog
                        params: {
                            affType: {
                                label: 'Affiliation Type',
                                id: 'affType',
                                type: 'dropdown',
                                items: [
                                    { text: 'Volunteer/Organization', value: 'vol_org' },
                                    { text: 'Volunteer/Activity', value: 'vol_ae' },
                                    { text: 'Organization/Organization', value: 'org_org' },
                                ],
                                paramIndex: 3,
                            },
                            recordSource_volId: {
                                label: 'Volunteer to Use',
                                type: 'dropdown',
                                id: 'recordSource_volId',
                                items: [
                                    { text: 'Source', value: 'source' },
                                    { text: 'Context Vol', value: 'contextVolId' },
                                    { text: 'Fixed', value: 'fixed' },
                                    { text: 'Selectable', value: 'selectable' },
                                    { text: 'No Vol ID', value: 'none' }
                                ],
                                fields: {
                                    text: 'text',
                                    value: 'value'
                                },
                                helpText: 'Choose "source" to use the record from the source component where the action is used.  Choose "fixed" to provide an ID for a specific record.  Choose "selectable" to ',
                                logic: [
                                    {
                                        criteriaRecord: 'self',
                                        record: 'component',
                                        prop: 'controlConfigs.param_volId.display',
                                        valueType: 'criteria',
                                        criteria: 'this.value === "fixed"'
                                    }
                                ],
                                default: 'selectable'
                            },
                            volId: {
                                label: 'Volunteer ID',
                                id: 'volId',
                                type: 'string',
                                display: false,
                                paramIndex: 0
                            },
                            recordSource_orgId: {
                                label: 'Organization to Use',
                                type: 'dropdown',
                                id: 'recordSource_orgId',
                                items: [
                                    { text: 'Source', value: 'source' },
                                    { text: 'Context Org', value: 'contextOrgId' },
                                    { text: 'Fixed', value: 'fixed' },
                                    { text: 'Selectable', value: 'selectable' },
                                    { text: 'No Org ID', value: 'none' }
                                ],
                                fields: {
                                    text: 'text',
                                    value: 'value'
                                },
                                helpText: 'Choose "source" to use the record from the source component where the action is used.  Choose "fixed" to provide an ID for a specific record.  Choose "selectable" to ',
                                logic: [
                                    {
                                        criteriaRecord: 'self',
                                        record: 'component',
                                        prop: 'controlConfigs.param_orgId.display',
                                        valueType: 'criteria',
                                        criteria: 'this.value === "fixed"'
                                    }
                                ],
                                default: 'source'
                            },
                            orgId: {
                                label: 'Organization ID',
                                id: 'orgId',
                                type: 'string',
                                display: false,
                                paramIndex: 1
                            },
                            fields: {
                                label: 'Fields',
                                type: 'dropdowntree',
                                itemsSource: 'configStore.allFieldOptions()',
                                allowFiltering: true,
                                showCheckBox: true,
                                allowMultiSelection: true,
                                filterType: 'contains',
                                fields: {
                                    text: 'text',
                                    value: 'value',
                                    parentValue: 'pId',
                                    hasChildren: 'hasChild'
                                },
                                default: [],
                                id: 'fields',
                                paramIndex: 2
                            }
                        },
                        pId: 'sds'
                    },
                    {
                        text: 'Availiability Windows',
                        value: 'sds_getAffAvailabilityWindows',
                        type: 'sds',
                        pId: 'sds',
                        params: {
                            affIds: {
                                label: 'Affiliation Ids',
                                id: 'affIds',
                                type: 'multiselect',
                                allowCustomValue: 'true',
                                paramIndex: 0
                            }
                        }
                    },
                    {
                        text: 'Volunteer Message List',
                        value: 'er_messageList',
                        type: 'sds',
                        // Params are configs for controls that are displayed to provide the params of the sDs call.
                        // They will be used by the checkParams function from the actionStore which displays a dialog
                        params: {
                            recordSource_volId: {
                                label: 'Volunteer to Use',
                                type: 'dropdown',
                                id: 'recordSource_volId',
                                items: [
                                    { text: 'Source', value: 'source' },
                                    { text: 'Context Vol', value: 'contextVolId' },
                                    { text: 'Fixed', value: 'fixed' },
                                    { text: 'Selectable', value: 'selectable' },
                                    { text: 'No Vol ID', value: 'none' }
                                ],
                                fields: {
                                    text: 'text',
                                    value: 'value'
                                },
                                helpText: 'Choose "source" to use the record from the source component where the action is used.  Choose "fixed" to provide an ID for a specific record.  Choose "selectable" to ',
                                logic: [
                                    {
                                        criteriaRecord: 'self',
                                        record: 'component',
                                        prop: 'controlConfigs.param_volId.display',
                                        valueType: 'criteria',
                                        criteria: 'this.value === "fixed"'
                                    }
                                ],
                                default: 'selectable'
                            },
                            volId: {
                                label: 'Volunteer ID',
                                id: 'volId',
                                type: 'string',
                                display: false,
                                paramIndex: 0
                            }
                        },
                        pId: 'sds'
                    },
                    {
                        text: 'Dataset History',
                        value: 'ec_getDatasetHistory',
                        type: 'sds',
                        // Params are configs for controls that are displayed to provide the params of the sDs call.
                        // They will be used by the checkParams function from the actionStore which displays a dialog
                        params: {
                            recordSource_datasetId: {
                                label: 'Record to Use',
                                type: 'dropdown',
                                id: 'recordSource_datasetId',
                                items: [
                                    { text: 'Context Dataset Id', value: 'contextDatasetId' },
                                ],
                                fields: {
                                    text: 'text',
                                    value: 'value'
                                },
                                logic: [
                                    {
                                        criteriaRecord: 'self',
                                        record: 'component',
                                        prop: 'controlConfigs.param_datasetId.display',
                                        valueType: 'criteria',
                                        criteria: 'this.value === "fixed"'
                                    }
                                ],
                                helpText: 'Choose "source" to use the record from the source component where the action is used',
                                default: 'selectable'
                            },
                            datasetId: {
                                label: 'Dataset ID',
                                id: 'datasetId',
                                type: 'string',
                                display: false,
                                paramIndex: 0
                            },
                        },
                        pId: 'sds'
                    },
                    {
                        text: 'History',
                        value: 'ec_getHistory',
                        type: 'sds',
                        // Params are configs for controls that are displayed to provide the params of the sDs call.
                        // They will be used by the checkParams function from the actionStore which displays a dialog
                        params: {
                            type: {
                                label: 'Type of Record',
                                type: 'dropdown',
                                fields: {
                                    text: 'text',
                                    value: 'value'
                                },
                                items: [
                                    { text: 'Volunteer', value: 'vol' },
                                    { text: 'Opportunity', value: 'opp' },
                                    { text: 'Organization', value: 'org' },
                                    { text: 'Affiliation', value: 'aff' },
                                    { text: 'Activity', value: 'ae' },
                                    { text: 'Logbook', value: 'lbe' },
                                ],
                                helpText: 'Perspective of record for your "Record to Use"',
                                paramIndex: 1,
                            },
                            recordSource_recordId: {
                                label: 'Record to Use',
                                type: 'dropdown',
                                id: 'recordSource_recordId',
                                items: [
                                    { text: 'Source', value: 'source' },
                                    { text: 'Context Vol', value: 'contextVolId' },
                                    { text: 'Context Org', value: 'contextOrgId' },
                                    { text: 'Context Opp', value: 'contextOppId' },
                                    { text: 'Context Aff', value: 'contextAffId' },
                                    { text: 'Context Ae', value: 'contextAeId' },
                                    { text: 'Context LBE', value: 'contextLbeId' },
                                    { text: 'Fixed', value: 'fixed' }
                                ],
                                fields: {
                                    text: 'text',
                                    value: 'value'
                                },
                                logic: [
                                    {
                                        criteriaRecord: 'self',
                                        record: 'component',
                                        prop: 'controlConfigs.param_recordId.display',
                                        valueType: 'criteria',
                                        criteria: 'this.value === "fixed"'
                                    }
                                ],
                                helpText: 'Choose "source" to use the record from the source component where the action is used.  Choose "fixed" to provide an ID for a specific record.  Choose "selectable" to ',
                                default: 'selectable'
                            },
                            recordId: {
                                label: 'Record ID',
                                id: 'recordId',
                                type: 'string',
                                display: false,
                                paramIndex: 0
                            },
                            filter: {
                                label: 'Type of History Filter',
                                type: 'dropdown',
                                fields: {
                                    text: 'text',
                                    value: 'value'
                                },
                                items: [
                                    { text: 'All', value: 'ALL' },
                                    { text: 'Change', value: 'CHANGE' },
                                    { text: 'Place', value: 'PLACE' },
                                    { text: 'Refer', value: 'REFER' },
                                    { text: 'Email', value: 'EMAIL' }
                                ],
                                paramIndex: 2
                            },
                        },
                        pId: 'sds'
                    },
                    {
                        text: 'Activities',
                        value: 'ec_getGrid',
                        // await sDs.post('ec_getGrid', 'ae', false, fields);
                        type: 'sds',
                        params: {
                            gridPsp: {
                                // This param is a fixed param
                                label: 'Perspective',
                                // type: 'string',
                                default: 'ae',
                                display: false,
                                paramIndex: 0
                            },
                            gridFields: {
                                label: 'Fields',
                                type: 'dropdowntree',
                                itemsSource: 'configStore.allFieldOptions(["ae"])',
                                allowFiltering: true,
                                showCheckBox: true,
                                allowMultiSelection: true,
                                filterType: 'contains',
                                fields: {
                                    text: 'text',
                                    value: 'value',
                                    parentValue: 'pId',
                                    hasChildren: 'hasChild'
                                },
                                default: [],
                                id: 'fields',
                                paramIndex: 2
                            }
                        },
                        addParamsIndex: 6,
                        pId: 'sds'
                    },
                    {
                        text: 'Activity Shifts',
                        value: 'sds_getAeSlotsList',
                        type: 'sds',
                        params: {
                            recordSource_aeId: createRecordSourceControl(
                                'aeId',
                                ['source', 'contextAeId', 'fixed', 'storeProp'],
                                ['ACTIVITY_ENTITY_ID', 'uiRecordId', 'ID'],
                                'Activity Record'
                            ),
                            aeId: {
                                label: 'Activity ID',
                                id: 'aeId',
                                type: 'string',
                                display: false,
                                paramIndex: 0
                            },
                            aeId_storeProp: {
                                label: 'Store Property',
                                id: 'aeId_storeProp',
                                type: 'string',
                            },
                            fields: {
                                label: 'Fields',
                                type: 'dropdowntree',
                                itemsSource: 'configStore.allFieldOptions()',
                                allowFiltering: true,
                                showCheckBox: true,
                                allowMultiSelection: true,
                                filterType: 'contains',
                                fields: {
                                    text: 'text',
                                    value: 'value',
                                    parentValue: 'pId',
                                    hasChildren: 'hasChild'
                                },
                                default: [],
                                id: 'fields',
                                paramIndex: 1
                            },
                            startDate: {
                                label: 'Start Date',
                                id: 'startDate',
                                type: 'date',
                                allowRelativeDate: true,
                                paramIndex: 2
                            },
                            endDate: {
                                label: 'End Date',
                                id: 'endDate',
                                type: 'date',
                                allowRelativeDate: true,
                                paramIndex: 3
                            },
                            rowCount: {
                                label: 'Max Records',
                                id: 'rowCount',
                                type: 'number',
                                paramIndex: 4
                            },
                            ignoreCache: {
                                label: 'Ignore Cache',
                                id: 'ignoreCache',
                                type: 'boolean',
                                paramIndex: 5
                            },
                            recordSource_aeSsOrgId: createRecordSourceControl(
                                'aeSsOrgId',
                                ['source', 'subSource', 'selectable', 'contextOrgId'],
                                ['ORGANIZATION_ID', 'AE_SS_ORGANIZATION_ID'],
                                'Activity Organization Source'
                            ),
                            subSourcePath: {
                                label: 'Activity Organization Sub-source Path',
                                id: 'subSourcePath',
                                type: 'string'
                            },
                            aeSsOrgId: {
                                label: 'Activity Organization ID',
                                id: 'aeSsOrgId',
                                type: 'string',
                                paramIndex: 9
                            },
                        },
                        addParamsIndex: 8,
                        pId: 'sds'
                    },
                    {
                        text: 'Placed Shifts List',
                        value: 'er_getPlacedSlotList',
                        type: 'sds',
                        pId: 'sds',
                        addParamsIndex: 7,
                        params: {
                            delimiter: {
                                type: 'string',
                                display: false,
                                default: false,
                                paramIndex: 0
                            },
                            fields: {
                                label: 'Fields',
                                type: 'dropdowntree',
                                isFieldsParam: true, // flags param as fields for field formatting
                                itemsSource: 'configStore.allFieldOptions(["sch"])',
                                allowFiltering: true,
                                showCheckBox: true,
                                allowMultiSelection: true,
                                filterType: 'contains',
                                fields: {
                                    text: 'text',
                                    value: 'value',
                                    parentValue: 'pId',
                                    hasChildren: 'hasChild'
                                },
                                default: [],
                                id: 'fields',
                                paramIndex: 1
                            },
                            endDate: {
                                label: 'End Date',
                                type: 'date',
                                id: 'endDate',
                                paramIndex: 2
                            },
                            startDate: {
                                label: 'Start Date',
                                type: 'date',
                                id: 'startDate',
                                paramIndex: 3
                            },
                            forSisId: {
                                type: 'boolean',
                                display: false,
                                default: false,
                                paramIndex: 4
                            },
                            recordSource_volId: createRecordSourceControl(
                                'volId',
                                ['source', 'contextVolId', 'fixed'],
                                ['VOLUNTEER_ID', 'uiRecordId', 'ID'],
                                'Volunteer Record Source'
                            ),
                            volId: {
                                label: 'Volunteer ID',
                                id: 'volId',
                                type: 'string',
                                display: false,
                                paramIndex: 5
                            },
                            activityEntitySlots: {
                                label: 'Return activity shifts',
                                type: 'boolean',
                                id: 'activityEntitySlots',
                                default: false,
                                message: 'Enabling this will toggle between activity shifts, or normal shifts.',
                                paramIndex: 6
                            },
                        }
                    },
                    {
                        text: 'Referred Shifts List',
                        value: 'er_getReferredSlotList',
                        type: 'sds',
                        pId: 'sds',
                        addParamsIndex: 7,
                        params: {
                            delimiter: {
                                type: 'string',
                                display: false,
                                default: false,
                                paramIndex: 0
                            },
                            fields: {
                                label: 'Fields',
                                type: 'dropdowntree',
                                isFieldsParam: true, // flags param as fields for field formatting
                                itemsSource: 'configStore.allFieldOptions(["sch"])',
                                allowFiltering: true,
                                showCheckBox: true,
                                allowMultiSelection: true,
                                filterType: 'contains',
                                fields: {
                                    text: 'text',
                                    value: 'value',
                                    parentValue: 'pId',
                                    hasChildren: 'hasChild'
                                },
                                default: [],
                                id: 'fields',
                                paramIndex: 1
                            },
                            endDate: {
                                label: 'End Date',
                                type: 'date',
                                id: 'endDate',
                                paramIndex: 2
                            },
                            startDate: {
                                label: 'Start Date',
                                type: 'date',
                                id: 'startDate',
                                paramIndex: 3
                            },
                            recordSource_volId: createRecordSourceControl(
                                'volId',
                                ['source', 'contextVolId', 'fixed'],
                                ['VOLUNTEER_ID', 'uiRecordId', 'ID'],
                                'Volunteer Record Source'
                            ),
                            volId: {
                                label: 'Volunteer ID',
                                id: 'volId',
                                type: 'string',
                                display: false,
                                paramIndex: 4
                            },
                            activityEntitySlots: {
                                label: 'Return activity shifts',
                                type: 'boolean',
                                id: 'activityEntitySlots',
                                default: false,
                                message: 'Enabling this will toggle between activity shifts, or normal shifts.',
                                paramIndex: 5
                            },
                        }
                    },
                    {
                        text: 'Referred Opp List',
                        value: 'er_getReferredOppList',
                        type: 'sds',
                        pId: 'sds',
                        updateFrequency: 0,
                        params: {
                            delimiter: {
                                id: 'delimiter',
                                default: false,
                                display: false,
                                paramIndex: 0
                            },
                            fields: {
                                label: 'Fields',
                                isFieldsParam: true, // flags param as fields for field formatting
                                type: 'dropdowntree',
                                itemsSource: 'configStore.allFieldOptions(["opp"])',
                                allowFiltering: true,
                                showCheckBox: true,
                                allowMultiSelection: true,
                                filterType: 'contains',
                                fields: {
                                    text: 'text',
                                    value: 'value',
                                    parentValue: 'pId',
                                    hasChildren: 'hasChild'
                                },
                                default: [],
                                id: 'fields',
                                paramIndex: 1
                            },
                            recordSource_volId: createRecordSourceControl(
                                'volId',
                                ['source', 'contextVolId', 'fixed'],
                                ['VOLUNTEER_ID', 'uiRecordId', 'ID'],
                                'Volunteer Record Source'
                            ),
                            volId: {
                                label: 'Volunteer ID',
                                type: 'string',
                                id: 'volId',
                                display: false,
                                paramIndex: 2
                            }
                        }
                    },
                    {
                        text: 'Placed Opp List',
                        value: 'er_getPlacedOppList',
                        type: 'sds',
                        pId: 'sds',
                        updateFrequency: 0,
                        params: {
                            delimiter: {
                                id: 'delimiter',
                                default: false,
                                display: false,
                                paramIndex: 0
                            },
                            fields: {
                                label: 'Fields',
                                type: 'dropdowntree',
                                isFieldsParam: true, // flags param as fields for field formatting
                                itemsSource: 'configStore.allFieldOptions(["opp"])',
                                allowFiltering: true,
                                showCheckBox: true,
                                allowMultiSelection: true,
                                filterType: 'contains',
                                fields: {
                                    text: 'text',
                                    value: 'value',
                                    parentValue: 'pId',
                                    hasChildren: 'hasChild'
                                },
                                default: [],
                                id: 'fields',
                                paramIndex: 1
                            },
                            forSisId: {
                                type: 'boolean',
                                display: false,
                                default: false,
                                paramIndex: 2
                            },
                            recordSource_volId: createRecordSourceControl(
                                'volId',
                                ['source', 'contextVolId', 'fixed'],
                                ['VOLUNTEER_ID', 'uiRecordId', 'ID'],
                                'Volunteer Record Source'
                            ),
                            volId: {
                                label: 'Volunteer ID',
                                type: 'string',
                                id: 'volId',
                                display: false,
                                paramIndex: 3
                            }
                        }
                    },
                    {
                        text: 'Volunteer Assignments List',
                        value: 'sds_getAssignmentList',
                        type: 'sds',
                        params: {
                            recordSource_volId: createRecordSourceControl(
                                'volId',
                                ['source', 'contextVolId', 'fixed'],
                                ['VOLUNTEER_ID', 'uiRecordId', 'ID'],
                                'Volunteer Record Source'
                            ),
                            volId: {
                                label: 'Volunteer ID',
                                id: 'volId',
                                type: 'string',
                                paramIndex: 0
                            },
                            fields: {
                                label: 'Fields',
                                type: 'dropdowntree',
                                itemsSource: 'configStore.allFieldOptions()',
                                allowFiltering: true,
                                showCheckBox: true,
                                allowMultiSelection: true,
                                filterType: 'contains',
                                fields: {
                                    text: 'text',
                                    value: 'value',
                                    parentValue: 'pId',
                                    hasChildren: 'hasChild'
                                },
                                default: [],
                                id: 'fields',
                                paramIndex: 1
                            },
                            recordSource_orgIds: createRecordSourceControl(
                                'orgIds',
                                ['source', 'contextOrgId', 'fixed'],
                                ['ORGANIZATION_ID', 'uiRecordId', 'ID'],
                                'Organization Record Source'
                            ),
                            params: {
                                label: 'sDs Request Params',
                                type: 'object',
                                properties: {
                                    strictTypeResults: {
                                        label: 'Return Strict Type Results',
                                        type: 'boolean',
                                        default: false
                                    }
                                },
                                paramIndex: 2,
                                display: false
                            }
                        },
                        pId: 'sds'
                    },
                    {
                        text: 'Assignment Detail Records',
                        value: 'sds_getDetailRecordList',
                        type: 'sds',
                        params: {
                            fields: {
                                label: 'Fields',
                                type: 'dropdowntree',
                                itemsSource: 'configStore.allFieldOptions(["org"])',
                                allowFiltering: true,
                                showCheckBox: true,
                                allowMultiSelection: true,
                                filterType: 'contains',
                                fields: {
                                    text: 'text',
                                    value: 'value',
                                    parentValue: 'pId',
                                    hasChildren: 'hasChild'
                                },
                                default: [],
                                id: 'fields',
                                paramIndex: 1
                            }
                        },
                        addParamsIndex: 1,
                        pId: 'sds'
                    },
                ];
            };
        },
        getDatasourceList(state) {
            return async function () {
                let output = [];
                let sdsList = configStore.getsDsList();
                let otherSourcesList = [
                    {
                        text: 'Other Sources',
                        value: 'other',
                        hasChild: true,
                        selectable: false,
                        htmlAttributes: { 'prevent-select': 'true' },
                    },
                    {
                        text: 'URL Parameters',
                        value: 'urlParameters',
                        type: 'other',
                        pId: 'other'
                    }
                ];
                output = sdsList;
                output = output.concat(otherSourcesList);
                output.push({
                    text: 'UI Tagged Records',
                    type: 'uiTag',
                    value: 'uiTag',
                    params: {
                        tagName: {
                            label: 'Tag Name',
                            id: 'tagName',
                            type: 'string'
                        },
                    }
                });
                if (!Array.isArray(state.cfg.datasetList)) {
                    await configStore.getDatasetList();
                }
                let datasets = [];
                if (typeof state.cfg.datasetList !== 'undefined' && Array.isArray(state.cfg.datasetList)) {
                    datasets = state.cfg.datasetList.map((dataset) => ({
                        ...dataset,
                        text: dataset.cTitle,
                        value: dataset.dsId,
                        type: 'dataset',
                        pId: 'datasets'
                    }));
                }

                datasets.push({
                    text: 'Datasets',
                    value: 'datasets',
                    hasChild: true,
                    selectable: false,
                    htmlAttributes: { 'prevent-select': 'true' },
                });
                output = output.concat(datasets);
                state.cfg.datasourceList = output;
                return output;
            };
        },
        getPdfTemplateList(state) {
            return async function (payload) {
                let [refresh] = Object.values(payload);
                return configStore.getData({ kName: 'pdfTemplateList', fName: 'sds_getPdfTemplateList', subKey: 'pdfEditor', refresh: refresh }, 'component');
            };
        },
        attrListOptions(state) {
            return async function (payload) {
                let [attrName, force] = Object.values(payload);
                if (!attrName) return [];
                if (typeof state.editorOptions.attrListOptions === 'undefined') state.editorOptions.attrListOptions = {};
                let existingData = state.editorOptions.attrListOptions[attrName];
                if (existingData && force) {
                    delete state.editorOptions.attrListOptions[attrName];
                    existingData = false;
                }
                if (existingData) return existingData;
                let attrList = await configStore.getAttrList([attrName]);
                let attrListOptions = [];
                for (let i in attrList) {
                    attrListOptions.push({ text: library.cloneObj(attrList[i]), value: parseInt(i, 10) });
                }
                state.editorOptions.attrListOptions[attrName] = attrListOptions;
                state.dataAge['editorOptions.attrListOptions.' + attrName] = moment().format("YYYY-MM-DD H:mm:ss");
                return state.editorOptions.attrListOptions[attrName];
            };
        },
        affStatusOptions(state) {
            return async function (payload) {
                let [force] = Object.values(payload);
                let existingData = state.editorOptions.affStatusOptions;
                if (!existingData && force) {
                    delete state.editorOptions.affStatusOptions;
                    existingData = false;
                }
                if (existingData) return existingData;
                let affStatuses = await configStore.getAttrList(['aff_status_2']);
                let affStatusOptions = [];
                for (let i in affStatuses) {
                    affStatusOptions.push({ text: library.cloneObj(affStatuses[i]), value: parseInt(i, 10) });
                }
                state.editorOptions.affStatusOptions = affStatusOptions;
                state.dataAge['editorOptions.affStatusOptions'] = moment().format("YYYY-MM-DD H:mm:ss");
                return state.editorOptions.affStatusOptions;
            };
        },
        affReasonOptions(state) {
            return async function (payload) {
                let [force] = Object.values(payload);
                let existingData = state.editorOptions.affReasonOptions;
                if (!existingData && force) {
                    delete state.editorOptions.affReasonOptions;
                    existingData = false;
                }
                if (existingData) return existingData;
                let affReasones = await configStore.getAttrList(['aff_reason_2']);
                let affReasonOptions = [];
                for (let i in affReasones) {
                    affReasonOptions.push({ text: library.cloneObj(affReasones[i]), value: parseInt(i, 10) });
                }
                state.editorOptions.affReasonOptions = affReasonOptions;
                state.dataAge['editorOptions.affReasonOptions'] = moment().format("YYYY-MM-DD H:mm:ss");
                return state.editorOptions.affReasonOptions;
            };
        },
        pdfTemplateOptions(state) {
            return async function (payload) {
                let [force] = Object.values(payload);
                let existingData = state.editorOptions.pdfTemplateOptions;
                if (existingData && force) {
                    delete state.editorOptions.pdfTemplateOptions;
                    existingData = false;
                }
                if (existingData) return existingData;
                let templateList = await configStore.getPdfTemplateList(force);
                templateList = Object.values(templateList);
                let pdfTemplateOptions = [];
                let hashes = [];
                for (let i in templateList) {
                    if (i === 'length') continue;
                    let tmpTemplate = templateList[i];
                    let addAttachId = true;
                    if (hashes.indexOf(tmpTemplate.ATTACH_FILE_HASH) === -1) {
                        hashes.push(tmpTemplate.ATTACH_FILE_HASH);
                        addAttachId = false;
                    }
                    tmpTemplate.text = tmpTemplate.MAC_FILE_NAME;
                    tmpTemplate.value = tmpTemplate.ATTACH_FILE_HASH + (addAttachId ? '__' + tmpTemplate.ATTACH_ID : '');
                    pdfTemplateOptions.push(tmpTemplate);
                }
                state.editorOptions.pdfTemplateOptions = pdfTemplateOptions;
                state.dataAge['editorOptions.pdfTemplateOptions'] = moment().format("YYYY-MM-DD H:mm:ss");
                return state.editorOptions.pdfTemplateOptions;
            };
        },
        attachTypeList(state) {
            return state.cfg.attachTypeList;
        },
        attachTypeListOptions(state) {
            return state.editorOptions.attachTypeList;
        },
        getAttachTypeList(state) {
            return async function (payload) {
                const INCLUDE_UDF = 1;
                let [recordId, psp] = Object.values(payload);
                state.dataAge['getAttachTypeList'] = moment().format("YYYY-MM-DD H:mm:ss");
                return configStore.getData({ kName: 'attachTypeList', fName: 'er_getAttachTypeList', subKey: recordId, useCaching: projectAllowsCaching, accountSpecific: true }, psp, INCLUDE_UDF);
            };
        },
        getAttachTypeListOptions(state) {
            return async function (payload) {
                let [recordId, psp, force] = Object.values(payload);
                let existingData = state.editorOptions.attachTypeList && state.editorOptions.attachTypeList[recordId];
                if (existingData && force) delete state.cfg.attachTypeList[recordId];
                else if (existingData) return existingData;
                await configStore.getAttachTypeList(recordId, psp);
                const componentAttachments = state.cfg.attachTypeList[recordId];
                const items = [];
                for (let i in componentAttachments) {
                    if (i === 'length') continue;
                    let additionalData = library.cloneObj(componentAttachments[i]);
                    if (i.includes('CUSTOM_ATTRIBUTE#')) {
                        additionalData.ATTACH_TYPE_ID ??= i;
                        componentAttachments[i].ATTACH_TYPE_TEXT ??= additionalData.CUSTOM_ATTRIBUTE_NAME;
                    }
                    additionalData.fullUrl = additionalData.ATTACH_FILE_URL;
                    items.push({
                        value: additionalData.ATTACH_ID || additionalData.ATTACH_TYPE_ID,
                        text: componentAttachments[i].ATTACH_TYPE_TEXT || componentAttachments[i].MAC_FILE_NAME,
                        additionalData: additionalData
                    });
                }
                if (!state.editorOptions.attachTypeList) state.editorOptions.attachTypeList = {};
                state.editorOptions.attachTypeList[recordId] = items;
                state.dataAge['editorOptions.attachTypeList'] = moment().format("YYYY-MM-DD H:mm:ss");
                return state.editorOptions.attachTypeList[recordId];
            };
        },
        getDatasetDetails(state) {
            return async function (payload) {
                let [dsIds] = Object.values(payload);
                // Find existing Datasets
                let newDsIds;
                if (Array.isArray(state.cfg.datasetDetailsList)) {
                    newDsIds = dsIds.filter((dsId) => !state.cfg.datasetDetailsList.find((dataset) => dataset.dsId === dsId));
                } else newDsIds = dsIds;
                if (!newDsIds || !newDsIds.length) return state.cfg.datasetDetailsList;
                if (!state.cfg.datasetList) await configStore.getDatasetList();
                let dsInfoPromises = [];
                state.cfg.datasetList.forEach((dataset) => {
                    if (dsIds.indexOf(dataset.dsId) !== -1) {
                        dsInfoPromises.push(sDs.post('sds_getDatasetInfo', dataset.dsId));
                    }
                });
                let dsColumnSummaryInfo = state.cfg.datasetDetailsList
                    ? library.cloneObj(state.cfg.datasetDetailsList)
                    : [];
                await library.promiseAllSettled(dsInfoPromises).then((responses) => {
                    responses.forEach((response) => {
                        if (response.value.status === 'success') {
                            dsColumnSummaryInfo.push(response.value.data);
                        }
                    });
                });
                state.cfg.datasetDetailsList = dsColumnSummaryInfo;
                state.dataAge['getDatasetDetails'] = moment().format("YYYY-MM-DD H:mm:ss");
                return state.cfg.datasetDetailsList;
            };
        },
        getDatasetColumnOptions(state) {
            return async function (payload) {
                let [dsIds] = Object.values(payload);
                if (!dsIds) return [];
                if (typeof dsIds === 'string') dsIds = [dsIds];
                if (typeof dsIds === 'object' && (!Array.isArray(dsIds) || !dsIds.length)) return []; // TODO possibly iterate through object keys later
                // Convert datasource control values to arrays of IDs as strings
                if (dsIds[0].source) {
                    dsIds = dsIds.map((iDsId) => iDsId.source[0]);
                }
                let newDsIds;
                if (Array.isArray(state.editorOptions.datasetColumnOptions)) {
                    newDsIds = dsIds.filter((dsId) => !state.editorOptions.datasetColumnOptions.find((dataset) => dataset.value === dsId));
                } else newDsIds = dsIds;
                if (!newDsIds || !newDsIds.length) {
                    if (!state.editorOptions.datasetColumnOptions) return [];
                    return state.editorOptions.datasetColumnOptions
                        .filter((dataset) => dsIds.indexOf(dataset.value) !== -1 || dsIds.indexOf(dataset.pId) !== -1);
                }
                await configStore.getDatasetDetails(newDsIds);
                let dsColumnOptions = state.editorOptions.datasetColumnOptions
                    ? library.cloneObj(state.editorOptions.datasetColumnOptions)
                    : [];
                // Local function used in the datasetDetailsList forEach
                let addColumns = (iDataset, currOutput) => {
                    iDataset.columns.forEach((column) => {
                        let colName;
                        if (column.colName.indexOf('CA#') === 0) colName = column.colName.split('#')[1];
                        else colName = column.colName.replace(/_/g, " ");
                        if (colName) {
                            let newOpt = (textAppend, valueAppend) => ({
                                text: colName + textAppend + ' from ' + iDataset.dsId,
                                value: iDataset.dsId + '::' + column.colName + valueAppend,
                                pId: iDataset.dsId,
                                dsId: iDataset.dsId
                            });
                            currOutput.push(newOpt(': Column Summary', '::columnSummary'));
                            currOutput.push(newOpt(': Is Empty', '::WITHOUT_VALUE'));
                            currOutput.push(newOpt(': Has Value', '::WITH_VALUE'));
                            currOutput.push(newOpt(': Sum of Values', '::COL_SUM'));
                        }
                    });
                };
                state.cfg.datasetDetailsList
                    .filter((dataset) => newDsIds.indexOf(dataset.dsId) !== -1)
                    .forEach((dataset) => {
                        // check for existing options
                        let existingOptions = dsColumnOptions.find((option) => option.value === dataset.dsId);
                        if (existingOptions) return;
                        dsColumnOptions.push({
                            text: dataset.cTitle,
                            value: dataset.dsId,
                            dsId: dataset.dsId,
                            selectable: false,
                            htmlAttributes: { 'prevent-select': 'true' },
                            hasChild: true
                        });
                        // Add parent option to option list
                        dsColumnOptions.push({
                            text: dataset.cTitle + ' Row Count',
                            value: dataset.dsId + '::rowCount',
                            dsId: dataset.dsId,
                            pId: dataset.dsId
                        });
                        // Add all other subOptions
                        if (dataset.columns) {
                            addColumns(dataset, dsColumnOptions);
                        }
                    });
                state.editorOptions.datasetColumnOptions = dsColumnOptions;
                state.dataAge['editorOptions.datasetColumnOptions'] = moment().format("YYYY-MM-DD H:mm:ss");
                return state.editorOptions.datasetColumnOptions
                    .filter((dataset) => dsIds.indexOf(dataset.value) !== -1 || dsIds.indexOf(dataset.pId) !== -1);
            };
        },
        allESTList(state) {
            return async function (payload) {
                let [estPsp, force] = Object.values(payload);
                if (!estPsp) estPsp = state.cfg.allFieldsListPspArray;
                let promises = [];
                if (Array.isArray(estPsp) && estPsp.length) {
                    for (let i in estPsp) {
                        promises.push(configStore.getESTList(estPsp[i], force));
                    }
                }
                await library.promiseAllSettled(promises);
                return state.cfg.est;
            };
        },
        allLogicClausesList(state) {
            return async function (payload) {
                let [fieldsPsp] = Object.values(payload);
                if (!fieldsPsp) fieldsPsp = state.cfg.allFieldsListPspArray;
                let promises = [];
                if (Array.isArray(fieldsPsp) && fieldsPsp.length) {
                    for (let i in fieldsPsp) {
                        promises.push(configStore.getAvailableLogicClauses(fieldsPsp[i]));
                    }
                }
                await library.promiseAllSettled(promises);
                return state.cfg.allLogicClauses;
            };
        },
        allFieldsList(state) {
            return async function (payload) {
                let [fieldsPsp, fields] = Object.values(payload);
                if (!fieldsPsp) fieldsPsp = state.cfg.allFieldsListPspArray;
                let promises = [];
                if (Array.isArray(fieldsPsp) && fieldsPsp.length) {
                    for (let i in fieldsPsp) {
                        promises.push(configStore.getAvailableFieldList(fieldsPsp[i], fields));
                    }
                }
                await library.promiseAllSettled(promises);
                return state.cfg.availableFields;
            };
        },
        allLogicClausesOptions(state) {
            return async function (payload) {
                let [fieldsPsp] = Object.values(payload);
                if (fieldsPsp && !Array.isArray(fieldsPsp)) fieldsPsp = [fieldsPsp];
                if (!fieldsPsp) fieldsPsp = state.cfg.allFieldsListPspArray;
                let existingData = state.editorOptions.allLogicClauses;
                for (let i in fieldsPsp) {
                    if (typeof state.editorOptions.allLogicClausesByPsp === 'undefined' || typeof state.editorOptions.allLogicClausesByPsp[fieldsPsp[i]] === 'undefined') existingData = false;
                }
                let sortFnc = (a, b) => {
                    let ta = (a.text || a.value).toLowerCase();
                    let tb = (b.text || b.value).toLowerCase();
                    if (ta < tb) return -1;
                    if (ta > tb) return 1;
                    return 0;
                };

                let resultFnc = () => {
                    let result = [];
                    for (let i in fieldsPsp) {
                        if (typeof state.editorOptions.allLogicClausesByPsp[fieldsPsp[i]] !== 'undefined') {
                            result = result.concat(library.cloneObj(state.editorOptions.allLogicClausesByPsp[fieldsPsp[i]], true));
                        }
                    }
                    return result.sort(sortFnc);
                };
                if (existingData) {
                    return resultFnc();
                }
                await configStore.allLogicClausesList(fieldsPsp);
                let fKeys = Object.keys(state.cfg.availableLogicClauses);
                let outputOptions = [];
                let outputOptionsByPsp = [];
                fKeys.sort();
                fKeys.forEach((type) => {
                    let parentField = library.cloneObj(state.cfg.availableLogicClauses[type], true);
                    let parentOption = {
                        text: configStore.pspParentNames[type],
                        value: type,
                        selectable: false,
                        htmlAttributes: { 'prevent-select': 'true' },
                        hasChild: true,
                    };
                    outputOptions.push(parentOption);
                    if (typeof outputOptionsByPsp[type] === 'undefined') outputOptionsByPsp[type] = [];
                    outputOptionsByPsp[type].push(parentOption);

                    if (type === 'lbe') {
                        let subParentOption = {
                            text: 'Training',
                            value: 'training',
                            selectable: false,
                            htmlAttributes: { 'prevent-select': 'true' },
                            hasChild: true,
                        };
                        outputOptions.push(subParentOption);
                        outputOptionsByPsp[type].push(subParentOption);

                        subParentOption = {
                            text: 'Waiver',
                            value: 'waiver',
                            selectable: false,
                            htmlAttributes: { 'prevent-select': 'true' },
                            hasChild: true,
                        };
                        outputOptions.push(subParentOption);
                        outputOptionsByPsp[type].push(subParentOption);
                    }
                    let cKeys = Object.keys(parentField);
                    cKeys.forEach((field) => {
                        let childFieldData = library.cloneObj(parentField[field], true);
                        let childValue;
                        if (!childFieldData.displayTitle) {
                            childFieldData.displayTitle = type + '::' + field;
                        }
                        if (field.indexOf('EMAIL_SAVED_TEMPLATE#') !== -1) return;
                        if (childFieldData.CUSTOM_ATTRIBUTE_CODE) childValue = "CA#" + childFieldData.CUSTOM_ATTRIBUTE_CODE;
                        else if (childFieldData.displayTitle.indexOf('::Attach/') !== -1) {
                            let fieldName = childFieldData.displayTitle.split('::Attach/')[1];
                            let isAttachUrl = fieldName.match(/ url/i);
                            let urlSuffixLength = ' url'.length;
                            if (isAttachUrl) isAttachUrl = isAttachUrl.index === fieldName.length - urlSuffixLength;
                            if (isAttachUrl) {
                                fieldName = fieldName.replace(/ url/i, '');
                                childValue = 'ATTACHURL#' + fieldName;
                            } else childValue = 'ATTACH#' + fieldName;
                        }
                        else childValue = field;
                        if (childFieldData && childFieldData.LOGIC && childFieldData.LOGIC.clauseType === 'empty') {
                            childFieldData.LOGIC.operands = [1];
                            childFieldData.LIST_VALUES = [
                                {
                                    label: 'Yes',
                                    value: 'Yes'
                                },
                                {
                                    label: 'No',
                                    value: 'No'
                                }
                            ];
                        }
                        // Adjust fields that are just for waivers and trainings
                        let tmpType = type;
                        let optionText = childFieldData.displayTitle;
                        if (type === 'lbe') {
                            if (childFieldData.grouping?.toLowerCase() === 'waiver') {
                                tmpType = 'waiver';
                                optionText = 'waiver::' + optionText.split('::')[1];
                            }
                            if (childFieldData.grouping?.toLowerCase() === 'training') {
                                tmpType = 'training';
                                optionText = 'training::' + optionText.split('::')[1];
                            }
                        }
                        let childOption = {
                            text: optionText,
                            value: tmpType + ':::' + childValue,
                            optionData: library.cloneObj(childFieldData, true),
                            psp: tmpType, // parent is psp (perspective)
                            pId: tmpType
                        };
                        outputOptions.push(library.cloneObj(childOption, true));
                        outputOptionsByPsp[type].push(library.cloneObj(childOption, true));
                        // Add Logged Data fields to trainings and waivers
                        if (tmpType === 'lbe') {
                            let addToOtherLbeTypes = (iType) => {
                                let iChildOption = library.cloneObj(childOption, true);
                                let iOptionText = childOption.text.split('::')[1];
                                iChildOption.pId = iType;
                                iChildOption.text = iType + '::' + iOptionText;
                                iChildOption.value = iType + ':::' + childValue;
                                iChildOption.psp = iType;
                                outputOptions.push(iChildOption);
                                // Push the duplicate fields back into the lbe perspective
                                outputOptionsByPsp.lbe.push(library.cloneObj(iChildOption, true));
                            };
                            addToOtherLbeTypes('waiver');
                            addToOtherLbeTypes('training');
                        }
                    });
                });
                state.editorOptions.allLogicClauses = outputOptions;
                state.dataAge['editorOptions.allLogicClauses'] = moment().format("YYYY-MM-DD H:mm:ss");
                state.editorOptions.allLogicClausesByPsp = outputOptionsByPsp;
                state.dataAge['editorOptions.allLogicClausesByPsp'] = moment().format("YYYY-MM-DD H:mm:ss");
                return resultFnc();
            };
        },
        allFieldOptions(state) {
            return async function (payload) {
                let [fieldsPsp, fields] = Object.values(payload);
                if (fieldsPsp && !Array.isArray(fieldsPsp)) fieldsPsp = [fieldsPsp];
                if (fields && !Array.isArray(fields)) fields = [fields];
                for (let i in fields) {
                    if (fields[i].indexOf(':::') !== -1) fields[i] = fields[i].split(':::')[1];
                }
                if (!fieldsPsp) fieldsPsp = state.cfg.allFieldsListPspArray;
                let existingData = state.editorOptions.allFieldOptions;
                for (let i in fieldsPsp) {
                    if (typeof state.editorOptions.allFieldOptionsByPsp === 'undefined' || typeof state.editorOptions.allFieldOptionsByPsp[fieldsPsp[i]] === 'undefined') existingData = false;
                }
                if (existingData) {
                    for (let i in fields) {
                        let fieldIndex = state.editorOptions.allFieldOptions.findIndex((tmp) => tmp.value.split(':::')[1] === fields[i]);
                        if (fieldIndex === -1) existingData = false;
                    }
                }

                let sortFnc = (a, b) => {
                    let ta = (a.text || a.value).toLowerCase();
                    let tb = (b.text || b.value).toLowerCase();
                    if (ta < tb) return -1;
                    if (ta > tb) return 1;
                    return 0;
                };

                let resultFnc = () => {
                    let result = [];
                    if (fields) {
                        for (let i in fields) {
                            let fieldIndex = state.editorOptions.allFieldOptions.findIndex((tmp) => tmp.value.split(':::')[1] === fields[i]);
                            if (fieldIndex >= 0) {
                                result = result.concat(state.editorOptions.allFieldOptions[fieldIndex]);
                            }
                        }
                    } else {
                        for (let i in fieldsPsp) {
                            if (typeof state.editorOptions.allFieldOptionsByPsp[fieldsPsp[i]] !== 'undefined') {
                                result = result.concat(state.editorOptions.allFieldOptionsByPsp[fieldsPsp[i]]);
                            }
                        }
                    }
                    return result.sort(sortFnc);
                };
                if (existingData) {
                    return resultFnc();
                }
                await configStore.allFieldsList(fieldsPsp, fields);
                await configStore.getAttrList(['aff_status_2', 'aff_reason_2']);
                let fKeys = Object.keys(state.cfg.availableFields);
                let outputOptions = [];
                let outputOptionsByPsp = [];
                fKeys.sort();
                fKeys.forEach((type) => {
                    let parentField = state.cfg.availableFields[type];
                    let parentOption = {
                        text: configStore.pspParentNames[type],
                        value: type,
                        selectable: false,
                        htmlAttributes: { 'prevent-select': 'true' },
                        hasChild: true,
                    };
                    outputOptions.push(parentOption);
                    if (typeof outputOptionsByPsp[type] === 'undefined') outputOptionsByPsp[type] = [];
                    outputOptionsByPsp[type].push(parentOption);
                    let cKeys = Object.keys(parentField);
                    cKeys.forEach((field) => {
                        let childFieldData = parentField[field];
                        let childValue;
                        if (!childFieldData.displayTitle) {
                            childFieldData.displayTitle = type + '::' + field;
                        }
                        if (field.indexOf('EMAIL_SAVED_TEMPLATE#') !== -1) return;
                        if (childFieldData.CUSTOM_ATTRIBUTE_CODE) childValue = "CA#" + childFieldData.CUSTOM_ATTRIBUTE_CODE;
                        else if (childFieldData.displayTitle.indexOf('::Attach/') !== -1) {
                            let fieldName = childFieldData.displayTitle.split('::Attach/')[1];
                            let isAttachUrl = fieldName.match(/ url/i);
                            let urlSuffixLength = ' url'.length;
                            if (isAttachUrl) isAttachUrl = isAttachUrl.index === fieldName.length - urlSuffixLength;
                            if (isAttachUrl) {
                                fieldName = fieldName.replace(/ url/i, '');
                                childFieldData.SIMPLE_TYPE = 'ATTACHMENT';
                                childValue = 'ATTACHURL#' + fieldName;
                            } else childValue = 'ATTACH#' + fieldName;
                        }
                        else childValue = field;
                        // Adjust SIMPLE_TYPE
                        // TODO Fix SIMPLE_TYPE to be all uppercase
                        if (field === 'LOGBOOK_START_DATE_COL' || field === 'LOGBOOK_END_DATE_COL') {
                            childFieldData.SIMPLE_TYPE = 'date';
                        } else if (field === 'VOL_PLACEMENT_WITH_OPP_IDS') {
                            childFieldData.SIMPLE_TYPE = 'array';
                        }
                        // Adjust Time Fields
                        if (field === 'SS_START_TIME' || field === 'SS_FINISH_TIME') {
                            childFieldData.SIMPLE_TYPE = 'time';
                        }
                        if (field === 'AFF_STATUS') {
                            childFieldData.SIMPLE_TYPE = 'LIST';
                            let listValues = [];
                            Object.keys(state.cfg.attrList.aff_status_2)
                                .forEach((id) => {
                                    let label = state.cfg.attrList.aff_status_2[id];
                                    listValues.push({ id, label });
                                });
                            childFieldData.LIST_VALUES = listValues;
                        }
                        if (field === 'AFF_REASON') {
                            childFieldData.SIMPLE_TYPE = 'LIST';
                            let listValues = [];
                            Object.keys(state.cfg.attrList.aff_reason_2)
                                .forEach((id) => {
                                    let label = state.cfg.attrList.aff_reason_2[id];
                                    listValues.push({ id, label });
                                });
                            childFieldData.LIST_VALUES = listValues;
                        }
                        // Adjust BC Status Date
                        if (field === 'VOL_BC_ASSIGNED_DATE') {
                            childFieldData.SIMPLE_TYPE = 'date';
                        }
                        let childOption = {
                            text: childFieldData.displayTitle,
                            value: type + ':::' + childValue,
                            optionData: childFieldData,
                            pId: parentOption.value,
                            type: childFieldData.SIMPLE_TYPE
                        };
                        outputOptions.push(childOption);
                        outputOptionsByPsp[type].push(childOption);
                    });
                });
                state.editorOptions.allFieldOptions = outputOptions;
                state.dataAge['editorOptions.allFieldOptions'] = moment().format("YYYY-MM-DD H:mm:ss");
                state.editorOptions.allFieldOptionsByPsp = outputOptionsByPsp;
                state.dataAge['editorOptions.allFieldOptionsByPsp'] = moment().format("YYYY-MM-DD H:mm:ss");
                return resultFnc();
            };
        },
        // getFieldConfig retrieves a data object for fields & Udfs
        getFieldConfig() {
            return async function (payload) {
                let [field] = Object.values(payload);
                if (!field) return {};
                const setType = (field) => {
                    let type = field?.INPUT_TYPE || field?.SIMPLE_TYPE || null;
                    let output;
                    if (type) type = type.toLowerCase();
                    switch (type) {
                        case 'string':
                        case 'url':
                        case 'special_string':
                        case 'text':
                            output = 'string';
                            break;
                        case 'date':
                        case 'datetime':
                            output = 'date';
                            break;
                        case 'time':
                            output = 'time';
                            break;
                        case 'integer':
                        case 'float':
                        case 'number':
                        case 'numeric':
                        case 'numeric_id':
                            output = 'number';
                            break;
                        case 'date_period':
                            output = 'date_period';
                            break;
                        case 'boolean':
                            output = 'boolean';
                            break;
                        case 'attachment':
                            output = 'upload';
                            break;
                        case 'checkbox':
                        case 'dropdown':
                        case 'dropdowntree':
                        case 'list':
                        case 'multiselect':
                        case 'radio':
                            output = field?.MULTIPLE === 1 ? 'multiselect' : 'dropdown';
                            break;
                        default:
                            output = 'string';
                    }
                    return output;
                };

                const fieldPsp = field.split(':::')[0];
                const fieldOptions = await configStore.allFieldOptions(fieldPsp, field);
                const dataObj = fieldOptions.find((data) => (data.value === field));
                if (!dataObj) return {};

                let childFieldData = dataObj.optionData;
                let label = 'Value';
                if (childFieldData.CUSTOM_ATTRIBUTE_LABEL) label = childFieldData.CUSTOM_ATTRIBUTE_LABEL;
                else if (childFieldData.displayTitle) label = `${childFieldData.displayTitle.split('::')[1]}`;
                let type = setType(childFieldData);
                let hasListValues = Array.isArray(childFieldData.LIST_VALUES) && childFieldData.LIST_VALUES.length;
                if (type === 'dropdown' && !hasListValues) type = 'string';
                let configOutput = {
                    fieldId: dataObj.value,
                    // items added below
                    // fields added below
                    label,
                    type,
                    showClearButton: true
                };
                // TODO create a common "server UDF to devdash control" formatting function
                if (childFieldData.MINVALUE) configOutput.minDate = new Date(childFieldData.MINVALUE);
                if (childFieldData.MAXVALUE) configOutput.maxDate = new Date(childFieldData.MAXVALUE);
                if (hasListValues) configOutput.items = childFieldData.LIST_VALUES;
                if (type === 'boolean') {
                    configOutput.items = [
                        { text: 'Yes', value: '1' },
                        { text: 'No', value: '0' }
                    ];
                    configOutput.type = 'dropdown';
                    hasListValues = true;
                }
                // Add fields obj to output with items
                if (hasListValues) {
                    let fieldsObj = configOutput.items[0].id && configOutput.items[0].label
                        ? { text: 'label', value: 'label' } // Note: params: { strictTypeResults: true } is not working for list values
                        : { text: 'text', value: 'value' };
                    if (configOutput.items.length) configOutput.fields = fieldsObj;
                }
                return configOutput;
            };
        },
        filteredESTOption(state) {
            return async function (payload) {
                let [estPsp, force] = Object.values(payload);
                if (typeof estPsp !== 'undefined' && !Array.isArray(estPsp) && estPsp) estPsp = [estPsp];
                estPsp = estPsp.map((psp) => (psp === 'assignment' ? 'aff' : psp));
                let tmpESTOptions = await configStore.allESTOptions(estPsp, force);
                tmpESTOptions = library.cloneObj(tmpESTOptions);

                if (typeof estPsp !== 'undefined' && estPsp.length) {
                    tmpESTOptions = tmpESTOptions.filter((tmpOption) => estPsp.indexOf(tmpOption.pId) !== -1 || estPsp.indexOf(tmpOption.value) !== -1);
                }
                return tmpESTOptions;
            };
        },
        allESTOptions(state) {
            return async function (payload) {
                let [estPsp, force] = Object.values(payload);
                if (estPsp && !Array.isArray(estPsp)) estPsp = [estPsp];
                if (!estPsp) estPsp = state.cfg.allFieldsListPspArray;
                let existingData = state.editorOptions.est;
                for (let i in estPsp) {
                    if (typeof state.editorOptions.estByPsp === 'undefined' || typeof state.editorOptions.estByPsp[estPsp[i]] === 'undefined' || force) existingData = false;
                }
                let sortFnc = (a, b) => {
                    let ta = (a.text || a.value).toLowerCase();
                    let tb = (b.text || b.value).toLowerCase();
                    if (ta < tb) return -1;
                    if (ta > tb) return 1;
                    return 0;
                };
                let resultFnc = () => {
                    let result = [];
                    for (let i in estPsp) {
                        if (typeof state.editorOptions.estByPsp[estPsp[i]] !== 'undefined') {
                            result = result.concat(state.editorOptions.estByPsp[estPsp[i]]);
                        }
                    }
                    return result.sort(sortFnc);
                };
                if (existingData) {
                    return resultFnc();
                }
                await configStore.allESTList(estPsp, force);
                let fKeys = Object.keys(state.cfg.est);
                let outputOptions = [];
                let outputEstByPsp = [];
                fKeys.sort();
                fKeys.forEach((type) => {
                    let parentEST = state.cfg.est[type];
                    let parentOption = {
                        text: configStore.pspParentNames[type],
                        value: type,
                        selectable: false,
                        htmlAttributes: { 'prevent-select': 'true' },
                        hasChild: true,
                    };
                    outputOptions.push(parentOption);
                    if (typeof outputEstByPsp[type] === 'undefined') outputEstByPsp[type] = [];
                    outputEstByPsp[type].push(parentOption);
                    let cKeys = Object.keys(parentEST);
                    for (let estId in parentEST) {
                        let childFieldData = parentEST[estId];
                        let childOption = {
                            text: parentEST[estId],
                            value: estId,
                            optionData: childFieldData,
                            pId: parentOption.value
                        };
                        outputOptions.push(childOption);
                        outputEstByPsp[type].push(childOption);
                    }
                });
                state.editorOptions.est = outputOptions;
                state.dataAge['editorOptions.est'] = moment().format("YYYY-MM-DD H:mm:ss");
                state.editorOptions.estByPsp = outputEstByPsp;
                state.dataAge['editorOptions.estByPsp'] = moment().format("YYYY-MM-DD H:mm:ss");
                return resultFnc();
            };
        },
        bcPackageOptions(state) {
            return async function () {
                let existingData = state.editorOptions.bcPackageOptions;
                if (existingData) return existingData;
                await configStore.getBcPackageList();
                let bcPackageList = Object.values(state.cfg.bcPackageList);
                let outputOptions = [];
                bcPackageList.forEach((bcPackage) => {
                    outputOptions.push({
                        text: bcPackage.BC_PACKAGE_NAME,
                        value: bcPackage.BC_PACKAGE_ID
                    });
                });
                state.editorOptions.bcPackageOptions = outputOptions;
                state.dataAge['editorOptions.bcPackageOptions'] = moment().format("YYYY-MM-DD H:mm:ss");
                return state.editorOptions.bcPackageOptions;
            };
        },
        allSurveyOptions(state) {
            return async function () {
                let typeKey = 'allSurveyOptions';
                let existingData = state.editorOptions[typeKey];
                if (existingData) return existingData;
                await configStore.getSurveyList();
                let outputOptions = [];
                let surveyList = Object.values(state.cfg.surveyList);
                let types = [
                    { label: 'Regular', value: 'regular' },
                    { label: 'Non-Opp', value: 'nonopp' }
                ];
                surveyList.forEach((survey) => {
                    // Add parent
                    let typeIndex = survey.DATA_PACKAGE_TYPE;
                    if (
                        !outputOptions.find((option) => option.hasChild && option.value === types[typeIndex].value)
                    ) {
                        outputOptions.push({
                            text: types[typeIndex].label,
                            value: types[typeIndex].value,
                            type: types[typeIndex].value,
                            selectable: false,
                            htmlAttributes: { 'prevent-select': 'true' },
                            hasChild: true
                        });
                    }
                    // Add option
                    outputOptions.push({
                        text: survey.DATA_PACKAGE_TITLE,
                        value: survey.DATA_PACKAGE_ID.toString(),
                        type: types[typeIndex].value,
                        pId: types[typeIndex].value
                    });
                });
                state.editorOptions[typeKey] = outputOptions;
                state.dataAge['editorOptions.' + typeKey] = moment().format("YYYY-MM-DD H:mm:ss");
                return state.editorOptions[typeKey];
            };
        },
        allWaiverOptions(state) {
            return async function () {
                let typeKey = 'allWaiverOptions';
                let existingData = state.editorOptions[typeKey];
                if (existingData) return existingData;
                await configStore.getWaiverList();
                let outputOptions = [];
                let waiverList = Object.keys(state.cfg.waiverList);
                waiverList.forEach((surveyId) => {
                    outputOptions.push({
                        text: state.cfg.waiverList[surveyId],
                        value: surveyId
                    });
                });
                state.editorOptions[typeKey] = outputOptions;
                state.dataAge['editorOptions.' + typeKey] = moment().format("YYYY-MM-DD H:mm:ss");
                return state.editorOptions[typeKey];
            };
        },
        allTrainingOptions(state) {
            return async function () {
                let typeKey = 'allTrainingOptions';
                let existingData = state.editorOptions[typeKey];
                if (existingData) return existingData;
                await configStore.getTrainingList();
                let outputOptions = [];
                let trainingList = Object.keys(state.cfg.trainingList);
                trainingList.forEach((trainingId) => {
                    let trainingObj = state.cfg.trainingList[trainingId];
                    outputOptions.push({
                        text: trainingObj.TRAINING_NAME,
                        value: trainingId + '_' + trainingObj.DATA_PACKAGE_ID[0],
                        permissions: trainingObj.DATA_PACKAGE_PERMISSIONS,
                        surveys: trainingObj.DATA_PACKAGE_ID
                    });
                });
                state.editorOptions[typeKey] = outputOptions;
                state.dataAge['editorOptions.' + typeKey] = moment().format("YYYY-MM-DD H:mm:ss");
                return state.editorOptions[typeKey];
            };
        },
        activityOptions(state) {
            return async function (payload) {
                let [workflowType, force] = Object.values(payload);
                if (!workflowType) workflowType = 0;
                let typeKey = workflowType === 0 ? 'orgActivityOptions' : 'oppActivityOptions';
                let existingData = state.editorOptions[typeKey];
                if (existingData && !force) return existingData;
                await configStore.getActivityList(workflowType);
                // TODO move this from here to another place
                let outputOptions = [
                    { AE_TITLE: 'New Activity', ACTIVITY_ENTITY_ID: -1 }
                ];
                outputOptions = [...outputOptions, ...state.cfg.activityList];
                state.editorOptions[typeKey] = outputOptions;
                state.dataAge['editorOptions.' + typeKey] = moment().format("YYYY-MM-DD H:mm:ss");
                return state.editorOptions[typeKey];
            };
        },
        workflowOptions(state) {
            return async function (payload) {
                let [force, workflowType] = Object.values(payload);
                if (!workflowType) workflowType = 0;
                let typeKey = workflowType === 0 ? 'orgWorkflowOptions' : 'oppWorkflowOptions';
                let existingData = state.editorOptions[typeKey];
                if (existingData && !force) return existingData;
                await configStore.getWorkflowList(workflowType);
                let outputOptions = [];
                let workflowList = Object.keys(state.cfg.workflowList);
                for (let wfId in state.cfg.workflowList) {
                    if (wfId === 'length') continue;
                    let wfOption = state.cfg.workflowList[wfId];
                    if (!wfOption.WORKFLOW_ID) continue;
                    outputOptions.push({
                        text: wfOption.WORKFLOW_TITLE,
                        value: wfOption.WORKFLOW_ID,
                        details: wfOption
                    });
                }
                state.editorOptions[typeKey] = outputOptions;
                state.dataAge['editorOptions.' + typeKey] = moment().format("YYYY-MM-DD H:mm:ss");
                return state.editorOptions[typeKey];
            };
        },
        getInstanceList() {
            return async function () {
                return configStore.getData({ kName: 'instanceList', fName: 'sds_getInstanceList', storeKey: library.getSessionStorage('devDashEnv') + '/sds_getInstanceList', useCaching: projectAllowsCaching }, 1);
            };
        },
        getTemplateList() {
            return async function () {
                return configStore.getData({ kName: 'templateList', fName: 'sds_getTemplateList', storeKey: library.getSessionStorage('devDashEnv') + '/sds_getTemplateList', useCaching: projectAllowsCaching });
            };
        },
        getComponentList() {
            return async function () {
                return configStore.getData({ kName: 'componentList', fName: 'sds_getComponentList', storeKey: library.getSessionStorage('devDashEnv') + '/sds_getComponentList', useCaching: projectAllowsCaching });
            };
        },
        getLogicOperatorsList() {
            return async function () {
                return configStore.getData({ kName: 'logicOperatorsList', fName: 'sds_getLogicOperatorsList', useCaching: projectAllowsCaching });
            };
        },
        getPSPList() {
            return async function () {
                return configStore.getData({ kName: 'pspList', fName: 'sds_getPSPList', useCaching: projectAllowsCaching });
            };
        },
        getLogicPossiblePspList() {
            return async function (payload) {
                let [psp] = Object.values(payload);
                return configStore.getData({ kName: 'logicPossiblePspList', subKey: psp, fName: 'sds_getLogicPossiblePspList', useCaching: projectAllowsCaching });
            };
        },
        getAccountSettings(state) {
            return async function (payload) {
                let [refresh] = Object.values(payload);
                return configStore.getData({ kName: 'accountSettings', fName: 'er_getAccountSettings', refresh: refresh, useCaching: projectAllowsCaching, accountSpecific: true });
            };
        },
        getDropdownSearchOptions(state) {
            return async function (payload) {
                let [columnName, pspID, refresh] = Object.values(payload);
                if (typeof state.cfg.dropdownSearchOptions?.[columnName]?.[pspID] !== 'undefined') {
                    return state.cfg.dropdownSearchOptions[columnName][pspID];
                }
                return configStore.getData({ kName: 'dropdownSearchOptions', fName: 'ec_getDropdownSearchOptions', subKey: columnName, additionalSubKey: pspID, refresh: refresh, useCaching: projectAllowsCaching, accountSpecific: true });
            };
        },
        clearEcUserProperty(state) {
            return async function (payload) {
                let [key] = Object.values(payload);
                if (key) {
                    delete state.cfg.ecUserProperty[key];
                } else {
                    delete state.cfg.ecUserProperty;
                }
            };
        },
        getEcUserProperty(state) {
            return async function (payload) {
                let [key, refresh] = Object.values(payload);
                return configStore.getData({ kName: 'ecUserProperty', fName: 'er_getEcUserProperty', subKey: key, refresh: refresh, useCaching: projectAllowsCaching, clientSpecific: true });
            };
        },
        getEcNavigation(state) {
            return async function (payload) {
                let [refresh] = Object.values(payload);
                return configStore.getData({ kName: 'ecUserNavigation', fName: 'ec_getNavigation', refresh: refresh, useCaching: projectAllowsCaching, clientSpecific: true });
            };
        },
        getProfileTabs(state) {
            return async function (payload) {
                let [pspID, refresh] = Object.values(payload);
                return configStore.getData({ kName: 'profileTabs', fName: 'ec_getProfileTabs', subKey: pspID, refresh: refresh, useCaching: projectAllowsCaching, clientSpecific: true });
            };
        },
        getProfileTabTemplate(state) {
            return async function (payload) {
                let [pspID, tabID, refresh] = Object.values(payload);
                return configStore.getData({ kName: 'profileTabTemplate', fName: 'ec_getProfileTabTemplate', subKey: pspID, additionalSubKey: tabID, refresh: refresh, useCaching: projectAllowsCaching, clientSpecific: true });
            };
        },
        getRecruiterSettings() {
            return async function () {
                return configStore.getData({ kName: 'recruiterSettings', fName: 'er_getRecruiterSettings', useCaching: projectAllowsCaching, accountSpecific: true });
            };
        },
        getSurveyList() {
            return async function () {
                return configStore.getData({ kName: 'surveyList', fName: 'er_getSurveyList', useCaching: projectAllowsCaching, accountSpecific: true }, false, false, false, ['DATA_PACKAGE_OPPORTUNITIES', 'DATA_PACKAGE_TYPE', 'DATA_PACKAGE_FIELDS']);
            };
        },
        getWaiverList(state) {
            return async function () {
                state.cfg.waiverList = false;
                let type = 2; // Waiver
                let response = await sDs.post('er_getSurveyList', false, false, type);
                if (response.status === 'success' && !library.objIsEmpty(response.data) && typeof (response.data) === 'object') {
                    state.cfg.waiverList = response.data;
                    if (response.fromServer) {
                        state.dataAge.waiverList = moment().format("YYYY-MM-DD H:mm:ss");
                    }
                }
                return state.cfg.waiverList;
            };
        },
        getTrainingList(state) {
            return async function () {
                state.cfg.trainingList = false;
                let surveyType = 3; // Training
                let promises = [
                    sDs.post('er_getSurveyList', false, false, surveyType),
                    sDs.post('er_getTrainingInfo')
                ];
                let setTrainingData = (type, promise) => {
                    if (promise.status !== 'fulfilled') return;
                    let response = promise.value;
                    if (response.status === 'success' && !library.objIsEmpty(response.data) && typeof (response.data) === 'object') {
                        state.cfg[type] = response.data;
                        if (response.fromServer) {
                            state.dataAge[type] = moment().format("YYYY-MM-DD H:mm:ss");
                        }
                    }
                };
                await library.promiseAllSettled(promises).then((responses) => {
                    setTrainingData('trainingSurveys', responses[0]);
                    setTrainingData('trainingList', responses[1]);
                });
                return state.cfg.trainingList;
            };
        },
        getWorkflowList(state) {
            return async function (payload) {
                let [workflowType] = Object.values(payload);
                if (!workflowType) workflowType = 0;
                state.cfg.workflowList = false;
                let response = await sDs.post('sds_getWorkflowList', workflowType);
                if (response.status === 'success') {
                    state.cfg.workflowList = response.data;
                }
                return state.cfg.workflowList;
            };
        },
        getActivityList(state) {
            return async function (payload) {
                state.cfg.activityList = false;
                let [workflowType] = Object.values(payload);
                if (!workflowType) workflowType = 0;
                let fields = { 'AE_TITLE': '', 'AE_DESCRIPTION': '', 'ACTIVITY_ENTITY_ID': '' };
                let typeField = workflowType === 1
                    ? 'AEPROFILE_AE_PROFILE_TYPE_OPTION_2'
                    : 'AEPROFILE_AE_PROFILE_TYPE_OPTION_1';
                let aeProfileType = await ddStore.getAlias('ACTIVITY_ENTITY', typeField);
                fields.AE_PROFILE_TYPE = aeProfileType;
                let response = await sDs.post('ec_getGrid', 'ae', false, fields, false, { 'AE_TITLE': 'A' });
                if (response.status === 'success') {
                    state.cfg.activityList = response.data;
                    let tmpUserStore = uStore();
                    if (Array.isArray(response.data) && Array.isArray(tmpUserStore?.userData?.coordinator?.availableActivities)) {
                        for (let i in response.data) {
                            if (tmpUserStore.userData.coordinator.availableActivities.findIndex((tmp) => tmp.ACTIVITY_ENTITY_ID === response.data[i].ACTIVITY_ENTITY_ID) === -1) {
                                tmpUserStore.userData.coordinator.availableActivities.push(response.data[i]);
                            }
                        }
                    }
                }
                return state.cfg.activityList;
            };
        },
        getBcPackageList() {
            return async function () {
                return configStore.getData({ kName: 'bcPackageList', fName: 'sds_getBcPackageList', useCaching: projectAllowsCaching, accountSpecific: true });
            };
        },
        getAutomationList(state) {
            return async function (payload) {
                let [psp, type, aeID, returnDisabled] = Object.values(payload);
                if (!type) type = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
                returnDisabled = returnDisabled || false;
                if (aeID) {
                    delete state.cfg.aeAutomationList;
                    return configStore.getData({ kName: 'aeAutomationList', fName: 'sds_getAutomationList', subKey: psp }, type, aeID, returnDisabled);
                }
                return configStore.getData({ kName: 'automationList', fName: 'sds_getAutomationList', subKey: psp, useCaching: projectAllowsCaching, accountSpecific: true }, type, false, returnDisabled);
            };
        },
        getAllAutomationList(state) {
            return async function (payload) {
                let [optionsPsp, optionsType, optionsAeID] = Object.values(payload);
                if (!optionsPsp) optionsPsp = state.cfg.allFieldsListPspArray;
                let promises = [];
                if (Array.isArray(optionsPsp) && optionsPsp.length) {
                    for (let i in optionsPsp) {
                        promises.push(configStore.getAutomationList(optionsPsp[i], optionsType, optionsAeID));
                    }
                }
                await library.promiseAllSettled(promises);
                return state.cfg.automationList;
            };
        },
        allAutomationOptions(state) {
            return async function (payload) {
                let [optionsPsp, optionsType, optionsAeID] = Object.values(payload);
                if (optionsAeID && parseInt(optionsAeID, 10) <= 0) return [];
                if (optionsPsp && !Array.isArray(optionsPsp)) optionsPsp = [optionsPsp];
                if (!optionsPsp) optionsPsp = state.cfg.allFieldsListPspArray;
                let existingData = state.editorOptions.allAutomationOptions;
                let existingDataByPsp = state.editorOptions.allAutomationOptionsByPsp;
                for (let i in optionsPsp) {
                    if (typeof existingDataByPsp === 'undefined' || typeof existingDataByPsp[optionsPsp[i]] === 'undefined') {
                        existingData = false;
                    }
                }
                let sortFnc = (a, b) => {
                    let ta = (a.text || a.value).toLowerCase();
                    let tb = (b.text || b.value).toLowerCase();
                    if (ta < tb) return -1;
                    if (ta > tb) return 1;
                    return 0;
                };

                let resultFnc = () => {
                    let result = [];
                    let existingDataByPsp = state.editorOptions.allAutomationOptionsByPsp;
                    for (let i in optionsPsp) {
                        if (typeof existingDataByPsp[optionsPsp[i]] !== 'undefined') {
                            result = result.concat(existingDataByPsp[optionsPsp[i]]);
                        }
                    }
                    if (parseInt(optionsAeID, 10) > 0) {
                        let tmpResult = [];
                        for (let i in result) {
                            if (!result[i].hasChild) tmpResult.push(result[i]);
                        }
                        result = tmpResult;
                    }
                    return result.sort(sortFnc);
                };
                if (existingData && !optionsAeID) {
                    return resultFnc();
                }
                await configStore.getAllAutomationList(optionsPsp, optionsType, optionsAeID);
                let outputOptions = [];
                let outputOptionsByPsp = {};
                let automationListObj = optionsAeID ? state.cfg.aeAutomationList : state.cfg.automationList;
                let aKeys = Object.keys(automationListObj);
                aKeys.sort();
                aKeys.forEach((type) => {
                    if (typeof outputOptionsByPsp[type] === 'undefined') outputOptionsByPsp[type] = [];
                    let parent = automationListObj[type];
                    let parentOption = {
                        text: configStore.pspParentNames[type],
                        value: type,
                        selectable: false,
                        htmlAttributes: { 'prevent-select': 'true' },
                        hasChild: true,
                    };
                    outputOptions.push(parentOption);
                    outputOptionsByPsp[type].push(parentOption);
                    let cKeys = Object.keys(parent);
                    cKeys.forEach((aId) => {
                        let child = parent[aId];
                        let childOption = {
                            text: optionsAeID ? (child.AUTOMATION_DETAIL_NAME ?? child.AUTOMATION_NAME) : child.AUTOMATION_NAME,
                            value: type + ':::' + child.AUTOMATION_ID,
                            optionData: child,
                            pId: parentOption.value
                        };
                        outputOptions.push(childOption);
                        outputOptionsByPsp[type].push(childOption);
                    });
                });
                state.editorOptions.allAutomationOptionsByPsp = outputOptionsByPsp;
                state.dataAge['editorOptions.allAutomationOptionsByPsp'] = moment().format("YYYY-MM-DD H:mm:ss");
                state.editorOptions.allAutomationOptions = outputOptions;
                state.dataAge['editorOptions.allAutomationOptions'] = moment().format("YYYY-MM-DD H:mm:ss");
                return resultFnc();
            };
        },
        getAvailableFieldList() {
            return async function (payload) {
                let [psp, fields] = Object.values(payload);
                if (fields) {
                    return configStore.getData({ kName: 'availableFields', fName: 'sds_getAvailableFields', subKey: psp, useCaching: projectAllowsCaching, accountSpecific: true, mergeData: true, refresh: true }, { columns: fields });
                }
                return configStore.getData({ kName: 'availableFields', fName: 'sds_getAvailableFields', subKey: psp, useCaching: projectAllowsCaching, accountSpecific: true }, fields);
            };
        },
        getAvailableLogicClauses() {
            return async function (payload) {
                let [psp] = Object.values(payload);
                return configStore.getData({ kName: 'availableLogicClauses', fName: 'sds_getAvailableLogicClauses', subKey: psp, useCaching: projectAllowsCaching, accountSpecific: true });
            };
        },
        getESTList(state) {
            return async function (payload) {
                let [psp, force] = Object.values(payload);
                if (force) delete state.cfg.est[psp];
                return configStore.getData({ kName: 'est', fName: 'sds_getESTList', subKey: psp, useIndexedDB: projectAllowsCaching, accountSpecific: true });
            };
        },
        getAttrList() {
            return async function (payload) {
                let [attr] = Object.values(payload);
                if (!Array.isArray(attr)) attr = [attr];
                return configStore.getData({ kName: 'attrList', fName: 'er_getAttrList', subKey: attr, useCaching: projectAllowsCaching, accountSpecific: true });
            };
        },
        getAttrListInfo() {
            return async function (payload) {
                let [attr] = Object.values(payload);
                if (!Array.isArray(attr)) attr = [attr];
                return configStore.getData({ kName: 'attrListInfo', fName: 'er_getAttrList', subKey: attr, useCaching: projectAllowsCaching, accountSpecific: true }, false, true);
            };
        },
        allVols(state) {
            return async function () {
                let output = [];
                let fields = { VOL_FIRST_NAME: "", VOL_LAST_NAME: "" };
                let response = await sDs.post('ec_getGrid', 'vol', false, fields);
                if (response.data) {
                    response.data.forEach((vol) => {
                        // TODO more formatting of the data for UI structure
                        vol.VOLUNTEER_ID = vol.rowID;
                        output.push(vol);
                    });
                }
                state.cfg.allVols = output;
                return state.cfg.allVols;
            };
        },
        allVolOptions(state) {
            return async function () {
                await configStore.allVols();
                let outputOptions = [];
                state.cfg.allVols.forEach((vol) => {
                    outputOptions.push({
                        text: vol.VOL_FIRST_NAME + vol.VOL_LAST_NAME,
                        value: vol.VOLUNTEER_ID
                    });
                });
                state.editorOptions.allVolOptions = outputOptions;
                state.dataAge['editorOptions.allVolOptions'] = moment().format("YYYY-MM-DD H:mm:ss");
                return state.editorOptions.allVolOptions;
            };
        },
        allOpps(state) {
            return async function () {
                let output = [];
                let fields = { OPP_TITLE: "", OPP_ORGANIZATION_ID: "" };
                let response = await sDs.post('ec_getGrid', 'opp', false, fields);
                if (response.data) {
                    response.data.forEach((opp) => {
                        opp.OPPORTUNITY_ID = opp.rowID;
                        output.push(opp);
                    });
                }
                state.cfg.allOpps = output;
                return state.cfg.allOpps;
            };
        },
        allOppOptions(state) {
            return async function () {
                await configStore.allOpps();
                let outputOptions = [];
                state.cfg.allOpps.forEach((opp) => {
                    outputOptions.push({
                        text: opp.OPP_TITLE,
                        value: opp.OPPORTUNITY_ID
                    });
                });
                state.editorOptions.allOppOptions = outputOptions;
                state.dataAge['editorOptions.allOppOptions'] = moment().format("YYYY-MM-DD H:mm:ss");
                return state.editorOptions.allOppOptions;
            };
        },
        allOrgs(state) {
            return async function () {
                let output = [];
                let fields = { ORG_TITLE: "" };
                let response = await sDs.post('ec_getGrid', 'org', false, fields);
                if (response.data) {
                    response.data.forEach((org) => {
                        org.ORGANIZATION_ID = org.rowID;
                        output.push(org);
                    });
                }
                state.cfg.allOrgs = output;
                return state.cfg.allOrgs;
            };
        },
        allOrgOptions(state) {
            return async function () {
                await configStore.allOrgs();
                let outputOptions = [];
                state.cfg.allOrgs.forEach((org) => {
                    outputOptions.push({
                        text: org.ORG_TITLE,
                        value: org.ORGANIZATION_ID
                    });
                });
                state.editorOptions.allOrgOptions = outputOptions;
                state.dataAge['editorOptions.allOrgOptions'] = moment().format("YYYY-MM-DD H:mm:ss");
                return state.editorOptions.allOrgOptions;
            };
        },
        getSavedGridList() {
            return async function (payload) {
                let [psp] = Object.values(payload);
                return configStore.getData({ kName: 'savedGridList', fName: 'sds_getSavedGridList', subKey: psp }, true);
            };
        },
        getAllSavedGridList(state) {
            return async function () {
                let promises = [
                    configStore.getSavedGridList('vol'),
                    configStore.getSavedGridList('opp'),
                    configStore.getSavedGridList('org'),
                    configStore.getSavedGridList('aff'),
                    configStore.getSavedGridList('lbe')
                ];
                await library.promiseAllSettled(promises);
                return state.cfg.savedGridList;
            };
        },
        allSavedGridOptions(state) {
            return async function () {
                let existingData = state.editorOptions.allSavedGridOptions;
                if (existingData) return existingData;
                await configStore.getAllSavedGridList();
                let outputOptions = [];
                let aKeys = Object.keys(state.cfg.savedGridList);
                aKeys.sort();
                aKeys.forEach((type) => {
                    let parent = state.cfg.savedGridList[type];
                    let parentOption = {
                        text: configStore.pspParentNames[type],
                        value: type,
                        selectable: false,
                        htmlAttributes: { 'prevent-select': 'true' },
                        hasChild: true,
                    };
                    outputOptions.push(parentOption);
                    let cKeys = Object.keys(parent);
                    cKeys.forEach((sgId) => {
                        let childOption = {
                            text: parent[sgId],
                            value: sgId,
                            pId: parentOption.value
                        };
                        outputOptions.push(childOption);
                    });
                });
                state.editorOptions.allSavedGridOptions = outputOptions;
                state.dataAge['editorOptions.allSavedGridOptions'] = moment().format("YYYY-MM-DD H:mm:ss");
                return state.editorOptions.allSavedGridOptions;
            };
        },
        getMainGrid() {
            return async function (payload) {
                let [psp] = Object.values(payload);
                return configStore.getData({ kName: 'mainGrid', fName: 'ec_getMainGridInfo', subKey: psp });
            };
        },
        getFolders(state) {
            return async function (payload) {
                let [psp, force] = Object.values(payload);
                if (state.cfg.folders && state.cfg.folders[psp].length && !force) {
                    return state.cfg.folders[psp];
                }
                let response = await sDs.post('ec_getMainGridInfo', 1, ['folders']);
                if (response && response.status === 'success' && response.data && response.data.folders) {
                    let tmpFolders = [];
                    for (let i in response.data.folders) {
                        if (i === 'length') continue;
                        let tmpFolder = library.cloneObj(response.data.folders[i]);
                        tmpFolder.text = response.data.folders[i].DATA_VIEW_NAME;
                        tmpFolder.value = response.data.folders[i].DATA_VIEW_ID;
                        tmpFolders.push(tmpFolder);
                    }
                    state.cfg.folders[psp] = tmpFolders;
                }
                return state.cfg.folders[psp];
            };
        },
        setGridSettings() {
            return async function (payload) {
                let [psp, params] = Object.values(payload);
                await sDs.post('ec_setGridSettings', psp, params);
                /*
                let response = await sDs.post('ec_setGridSettings', psp, params);
                if (response && response.status === 'success') {
                    if (typeof params.CLIENT_GRID_SAVED_ID === 'undefined') params.CLIENT_GRID_SAVED_ID = null;
                    await configStore.getGridSettings(psp, params.CLIENT_GRID_SAVED_ID, true);
                } */
            };
        },
        getGridSettings(state) {
            return async function (payload) {
                let [psp, gridId, force] = Object.values(payload);
                if (state.cfg.gridSettings && state.cfg.gridSettings[psp] && typeof state.cfg.gridSettings[psp][gridId] !== 'undefined' && !force) {
                    return state.cfg.gridSettings[psp][gridId];
                }
                let sDsParams = {
                    sDsParams: {}
                };
                if (force) {
                    sDsParams.sDsParams.force = true;
                }
                let response = await sDs.post('ec_getGridSettings', psp, gridId, sDsParams);
                if (typeof state.cfg.gridSettings === 'undefined') state.cfg.gridSettings = {};
                if (typeof state.cfg.gridSettings[psp] === 'undefined') state.cfg.gridSettings[psp] = {};
                if (typeof state.cfg.gridSettings[psp][gridId] === 'undefined') state.cfg.gridSettings[psp][gridId] = [];
                if (response && response.status === 'success' && response.data) {
                    state.cfg.gridSettings[psp][gridId] = response.data;
                }
                return state.cfg.gridSettings[psp][gridId];
            };
        },
        getAvailableFF(state) {
            return function (payload) {
                let [ffName] = Object.values(payload);
                let enabled = false;
                for (let i in state.cfg.clientFF) {
                    if (i === 'length') continue;
                    for (let j in state.cfg.clientFF[i]) {
                        if (j === 'length') continue;
                        if (state.cfg.clientFF[i][j].value === ffName) {
                            enabled = state.cfg.clientFF[i][j];
                        }
                    }
                }
                return enabled;
            };
        },
        getAllClientFFList(state) {
            return async function () {
                if (typeof state.cfg.clientFF !== 'undefined') return state.cfg.clientFF;
                let response = await sDs.post('sds_getClientFF');
                let ffList = {};
                if (response && response.status === 'success' && response.data) {
                    for (let i in response.data) {
                        if (i === 'length') continue;
                        if (typeof ffList[response.data[i].GROUP] === 'undefined') ffList[response.data[i].GROUP] = [];
                        ffList[response.data[i].GROUP].push({
                            text: response.data[i].NAME,
                            value: response.data[i].CONSTANT
                        });
                    }
                    state.cfg.clientFF = ffList;
                }
                return state.cfg.clientFF;
            };
        },
        getFiltersList() {
            return async function (payload) {
                let [psp] = Object.values(payload);
                return configStore.getData({ kName: 'filtersList', fName: 'sds_getFiltersList', subKey: psp, useCaching: projectAllowsCaching, accountSpecific: true }, true);
            };
        },
        getAllFiltersList(state) {
            return async function () {
                let promises = [
                    configStore.getFiltersList('vol'),
                    configStore.getFiltersList('opp'),
                    configStore.getFiltersList('org'),
                    configStore.getFiltersList('aff'),
                    configStore.getFiltersList('lbe'),
                ];
                await library.promiseAllSettled(promises);
                return state.cfg.filtersList;
            };
        },
        allFiltersOptions(state) {
            return async function () {
                let existingData = state.editorOptions.allFiltersOptions;
                if (existingData) return existingData;
                await configStore.getAllFiltersList();
                let outputOptions = [];
                let aKeys = Object.keys(state.cfg.filtersList);
                aKeys.sort();
                aKeys.forEach((type) => {
                    let parent = state.cfg.filtersList[type];
                    let parentOption = {
                        text: configStore.pspParentNames[type],
                        value: type,
                        selectable: false,
                        htmlAttributes: { 'prevent-select': 'true' },
                        hasChild: true,
                    };
                    outputOptions.push(parentOption);
                    let cKeys = Object.keys(parent);
                    cKeys.forEach((fId) => {
                        let childOption = {
                            text: parent[fId],
                            value: fId,
                            pId: parentOption.value
                        };
                        outputOptions.push(childOption);
                    });
                });
                state.editorOptions.allFiltersOptions = outputOptions;
                state.dataAge['editorOptions.allFiltersOptions'] = moment().format("YYYY-MM-DD H:mm:ss");
                return state.editorOptions.allFiltersOptions;
            };
        },
        getData(state) {
            return async function (payload) {
                let [settings] = Object.values(payload);
                // eslint-disable-next-line object-curly-newline
                let { kName, fName, subKey, additionalSubKey, refresh, storeKey, useCaching, accountSpecific, clientSpecific, mergeData, mergePrimaryKey } = settings;
                // Create arguments for sDs call
                let args = [];
                if (typeof fName !== 'undefined') args.push(fName);
                if (typeof subKey !== 'undefined') args.push(subKey);
                if (typeof additionalSubKey !== 'undefined') args.push(additionalSubKey);
                let tmpArgs = Object.values(payload);
                for (let i = 1; i < tmpArgs.length; i++) {
                    args.push(tmpArgs[i]);
                }

                if (typeof subKey === 'undefined') {
                    if (state.cfg[kName] && !refresh) return state.cfg[kName];
                    if (!mergeData) state.cfg[kName] = false;
                } else {
                    if (additionalSubKey) {
                        if (state.cfg[kName] && state.cfg[kName][subKey] && state.cfg[kName][additionalSubKey] && !refresh) return state.cfg[kName][subKey][additionalSubKey];
                        if (typeof state.cfg[kName] === 'undefined') {
                            state.cfg[kName] = {};
                            if (typeof state.cfg[kName][subKey] === 'undefined') state.cfg[kName][subKey] = {};
                            state.cfg[kName][subKey][additionalSubKey] = false;
                        }
                    } else {
                        if (state.cfg[kName] && state.cfg[kName][subKey] && !refresh) return state.cfg[kName][subKey];
                        if (typeof state.cfg[kName] === 'undefined') {
                            state.cfg[kName] = {};
                            if (kName === 'attrList' && Array.isArray(subKey)) {
                                subKey.forEach((iSubKey) => {
                                    state.cfg[kName][iSubKey] = false;
                                });
                            }
                            else state.cfg[kName][subKey] = false;
                        }
                    }
                }
                let sDsParams = {};
                if (kName !== 'attachTypeList' && kName !== 'pdfTemplateList') {
                    sDsParams = {
                        sDsParams: {
                            cache: false
                        }
                    };
                    if (kName === 'availableFields') {
                        sDsParams.sDsParams.combine = true;
                    }
                }
                if (!library.objIsEmpty(sDsParams)) args.push(sDsParams);
                let response;
                // check for data in Caching
                let idbKey = storeKey || fName;
                // create Caching Key
                if (useCaching) {
                    if (subKey) idbKey += '/' + subKey;
                    if (additionalSubKey) idbKey += '/' + additionalSubKey;
                    if (clientSpecific) {
                        accountSpecific = true;
                    }
                    if (accountSpecific) {
                        let instance = await configStore.getDevDashLocalInstanceDetails();
                        // If getDevDashLocalInstanceDetails was called before being logged in there is no ACCOUNT_ID
                        if (!instance.ACCOUNT_ID) instance = await configStore.getDevDashLocalInstanceDetails({ refresh: true, addToSessionStorage: true });
                        if (!instance.ACCOUNT_ID) instance.ACCOUNT_ID = 'default';
                        idbKey += '/' + instance.name + '/' + instance.ACCOUNT_ID;
                        let activeUser = uStore().activeUser;
                        if (clientSpecific && activeUser && activeUser.CLIENT_ID) {
                            idbKey += '/' + activeUser.CLIENT_ID;
                        }
                    }
                }
                if (useCaching && !refresh) {
                    let isUpdated = await sDs.compareDataAge(idbKey);
                    if (!isUpdated) response = await library.cachedTransaction('get', idbKey);
                }
                // get response
                if (!response || response.status !== 'success') {
                    response = await sDs.post.apply(null, args);
                }
                let responseHasData = (res) => res.status === 'success'
                        && res.data !== null
                        && (
                            (typeof res.data === 'string' && library.isJson(res.data))
                            || (typeof (res.data) === 'object' && !library.objIsEmpty(res.data))
                        );
                if (responseHasData(response)) {
                    if (useCaching && !response.fromCaching) {
                        await library.cachedTransaction('put', idbKey, JSON.stringify(response.data));
                    }
                    if (subKey && additionalSubKey) {
                        if (typeof state.cfg[kName][subKey] === 'undefined') state.cfg[kName][subKey] = {};
                        if (typeof state.cfg[kName][subKey][additionalSubKey] === 'undefined') state.cfg[kName][subKey][additionalSubKey] = {};
                        state.cfg[kName][subKey][additionalSubKey] = response.data;
                        if (response.fromServer) {
                            state.dataAge[fName + '_' + subKey + '_' + additionalSubKey] = moment().format("YYYY-MM-DD H:mm:ss");
                        }
                    } else if (subKey) {
                        if ((kName === 'attrList' || kName === 'availableLogicClauses') && Array.isArray(subKey)) {
                            subKey.forEach((iSubKey) => {
                                state.cfg[kName][iSubKey] = subKey.length === 1 ? response.data : response.data[iSubKey];
                            });
                        }
                        else {
                            state.cfg[kName][subKey] = mergeData ? library.mergeObj(state.cfg[kName][subKey], response.data) : response.data;
                        }
                        if (response.fromServer) {
                            state.dataAge[fName + '_' + subKey] = moment().format("YYYY-MM-DD H:mm:ss");
                        }
                    } else if (kName === 'customPalettes') {
                        let formattedData = JSON.parse(response.data);
                        // Check for parent custom option
                        let hasCustomPalette = Array.isArray(formattedData) && formattedData.length;
                        const parentIndex = formattedData.findIndex((palette) => palette.id === 'customPalettes');
                        if (hasCustomPalette && parentIndex === -1) {
                            let customParentOption = {
                                id: 'customPalettes',
                                title: 'Custom Palettes',
                                hasChild: true,
                                standard: true,
                                expanded: true,
                                selectable: false,
                                htmlAttributes: { 'prevent-select': 'true' },
                            };
                            formattedData.unshift(customParentOption);
                        }
                        state.cfg[kName] = formattedData;
                    } else {
                        if (mergeData) {
                            let objIsArray = (el) => typeof parseFloat(el) === 'number' && !isNaN(parseFloat(el));
                            let responseIsArray = typeof response.data === 'object' && response.data !== null ? Object.keys(response.data).every(objIsArray) : false;
                            let stateIsArray = typeof state.cfg[kName] === 'object' && state.cfg[kName] !== null ? Object.keys(state.cfg[kName]).every(objIsArray) : false;
                            let tmpNewValue = state.cfg[kName];
                            if (!tmpNewValue) {
                                // if previous value of state is not setted
                                // we should set empty array/object base on response
                                // because library.mergeObj({}, []) = {}, library.mergeObj([], {}) = []
                                tmpNewValue = responseIsArray ? [] : {};
                            }
                            if (responseIsArray && stateIsArray && mergePrimaryKey) {
                                // for array we should have primaryKey for properly merge, otherwise library.mergeObj([0], [1]) = [1]
                                for (let i in response.data) {
                                    let finded = Object.values(state.cfg[kName]).find((tmp) => tmp[mergePrimaryKey] === response.data[i][mergePrimaryKey]);
                                    if (!finded) {
                                        let tmpKeys = Object.keys(state.cfg[kName]);
                                        let lastKey = tmpKeys[tmpKeys.length - 1];
                                        if (typeof parseFloat(lastKey) === 'number' && !isNaN(parseFloat(lastKey))) {
                                            tmpNewValue[parseFloat(lastKey) + 1] = response.data[i];
                                        }
                                    }
                                }
                            } else {
                                tmpNewValue = library.mergeObj(tmpNewValue, response.data);
                            }
                            state.cfg[kName] = library.cloneObj(tmpNewValue);
                        } else state.cfg[kName] = response.data;
                        if (response.fromServer) {
                            state.dataAge[fName] = moment().format("YYYY-MM-DD H:mm:ss");
                        }
                    }
                }
                // this is for self-hosted clients, DO NOT REMOVE
                if (kName === 'templateList' && !state.cfg[kName]) {
                    state.cfg[kName] = library.cloneObj(localLayouts);
                }
                let result = state.cfg[kName];
                if (subKey && additionalSubKey) {
                    result = state.cfg[kName][subKey][additionalSubKey];
                } else if (subKey) {
                    result = state.cfg[kName][subKey];
                }
                return result;
            };
        },
        getDateFormat(state) {
            return function (payload) {
                let dateFormat = 'YYYY-MM-DD';
                if (state.cfg.accountSettings && state.cfg.accountSettings['ACCOUNT_DATE_FORMAT']) {
                    switch (state.cfg.accountSettings['ACCOUNT_DATE_FORMAT']) {
                        case 'j M Y':
                            dateFormat = 'D MMM YYYY';
                            break;
                        case 'm/d/Y':
                            dateFormat = 'MM/DD/YYYY';
                            break;
                    }
                }
                return dateFormat;
            };
        },
        getDate(state) {
            return function (payload) {
                let [dateStr, withTime] = Object.values(payload);
                let dateTime = moment(dateStr);
                let dateFormat = 'YYYY-MM-DD';
                if (state.cfg.accountSettings && state.cfg.accountSettings['ACCOUNT_DATE_FORMAT']) {
                    switch (state.cfg.accountSettings['ACCOUNT_DATE_FORMAT']) {
                        case 'j M Y':
                            dateFormat = 'D MMM YYYY';
                            break;
                        case 'm/d/Y':
                            dateFormat = 'MM/DD/YYYY';
                            break;
                    }
                }
                let timeFormat = 'H:mm:ss';
                if (state.cfg.accountSettings && state.cfg.accountSettings['ACCOUNT_TIME_FORMAT']) {
                    switch (state.cfg.accountSettings['ACCOUNT_TIME_FORMAT']) {
                        case 'g:i A':
                            timeFormat = 'h:mm A';
                            break;
                        case 'G:i':
                            timeFormat = 'H:mm';
                            break;
                    }
                }
                let result = dateTime.format(dateFormat) + (withTime ? ' ' + dateTime.format(timeFormat) : '');
                return result;
            };
        },
        itemsSourceOptions(state) {
            return async function () {
                let setStoreProps = (items, stores) => {
                    for (let i in stores) {
                        if (i === 'length') continue;
                        let storeName = stores[i];
                        let parentAdded = false;
                        let addParent = () => {
                            if (!parentAdded) {
                                let item = {
                                    text: storeName,
                                    value: storeName,
                                    hasChild: true,
                                    selectable: false,
                                    htmlAttributes: { 'prevent-select': 'true' },
                                };
                                items.push(item);
                                parentAdded = true;
                            }
                        };
                        for (let prop in store[storeName]) {
                            if (prop === 'length') continue;
                            if (store[storeName] && store[storeName].state && Array.isArray(store[storeName].state.canBeUsedAsItemsSource) && store[storeName].state.canBeUsedAsItemsSource.indexOf(prop) !== -1) {
                                addParent();
                                let childItem = {
                                    text: storeName + '.' + prop + '()',
                                    value: storeName + '.' + prop + '()',
                                    pId: storeName
                                };
                                items.push(childItem);
                            }
                        }
                    }
                };
                if (!state.editorOptions.itemsSourceOptions) {
                    let items = [];
                    let stores = ['uStore', 'configStore', 'componentStore', 'actionStore'];
                    setStoreProps(items, stores);
                    state.editorOptions.itemsSourceOptions = items;
                }
                return state.editorOptions.itemsSourceOptions;
            };
        },
        testAsyncOptions() {
            return async function () {
                return new Promise((resolve) => {
                    setTimeout(() => {
                        resolve([
                            { text: 'Test Checkbox 1', value: 'val1' },
                            { text: 'Test Checkbox 2', value: 'val2' },
                            { text: 'Test Checkbox 3', value: 'val3' },
                        ]);
                    }, 6000); // NOSONAR
                });
            };
        }
    },
    actions: {
        updateDateTime({ state, commit }) {
            let dateTime = moment();
            let dateFormat = 'YYYY-MM-DD';
            if (state.cfg.accountSettings && state.cfg.accountSettings['ACCOUNT_DATE_FORMAT']) {
                switch (state.cfg.accountSettings['ACCOUNT_DATE_FORMAT']) {
                    case 'j M Y':
                        dateFormat = 'D MMM YYYY';
                        break;
                    case 'm/d/Y':
                        dateFormat = 'MM/DD/YYYY';
                        break;
                }
            }
            let timeFormat = 'H:mm:ss';
            if (state.cfg.accountSettings && state.cfg.accountSettings['ACCOUNT_TIME_FORMAT']) {
                switch (state.cfg.accountSettings['ACCOUNT_TIME_FORMAT']) {
                    case 'g:i A':
                        timeFormat = 'h:mm A';
                        break;
                    case 'G:i':
                        timeFormat = 'H:mm';
                        break;
                }
            }
            state.cfg.currentDate = dateTime.format(dateFormat);
            state.cfg.currentTime = dateTime.format(timeFormat);
            state.cfg.currentYear = dateTime.format("YYYY");
            state.cfg.currentMonth = parseInt(dateTime.format("M"), 10);
            state.cfg.currentMonthName = dateTime.format("MMMM");
            state.cfg.currentWeekDay = parseInt(dateTime.day(), 10);
            state.cfg.currentWeekDayName = dateTime.format("dddd");
            state.cfg.currentMonthDay = parseInt(dateTime.format("D"), 10);
            state.cfg.currentYearDay = dateTime.dayOfYear();
            if (!state.cfg.dateTimeUpdateInterval) {
                state.cfg.dateTimeUpdateInterval = setInterval(() => {
                    commit('updateTime', [dateFormat, timeFormat]);
                }, 1000); // NOSONAR
            }
        },
        setCommonDates({ state }) {
            let unixFormat = 'x';
            state.cfg.unixDates = {
                startOfToday: moment()
                    .startOf('day')
                    .format(unixFormat),
                endOfToday: moment()
                    .endOf('day')
                    .format(unixFormat),
                startOfYesterday: moment()
                    .subtract(1, 'days')
                    .startOf('day')
                    .format(unixFormat),
                endOfYesterday: moment()
                    .subtract(1, 'days')
                    .endOf('day')
                    .format(unixFormat),
                startOfWeek: moment()
                    .startOf('isoWeek')
                    .format(unixFormat),
                endOfWeek: moment()
                    .endOf('isoWeek')
                    .format(unixFormat),
                startOfMonth: moment()
                    .startOf('months')
                    .format(unixFormat),
                endOfMonth: moment()
                    .endOf('months')
                    .format(unixFormat),
                startOfYear: moment()
                    .startOf('years')
                    .format(unixFormat),
                endOfYear: moment()
                    .endOf('years')
                    .format(unixFormat),
                startOfLastWeek: moment()
                    .subtract(1, 'isoWeek')
                    .startOf('isoWeek')
                    .format(unixFormat),
                endOfLastWeek: moment()
                    .subtract(1, 'isoWeek')
                    .endOf('isoWeek')
                    .format(unixFormat),
                startOfLastMonth: moment()
                    .subtract(1, 'months')
                    .startOf('month')
                    .format(unixFormat),
                endOfLastMonth: moment()
                    .subtract(1, 'months')
                    .endOf('month')
                    .format(unixFormat),
                startOfLastYear: moment()
                    .subtract(1, 'years')
                    .startOf('year')
                    .format(unixFormat),
                endOfLastYear: moment()
                    .subtract(1, 'years')
                    .endOf('year')
                    .format(unixFormat)
            };
        },
        async addPalette({ state, commit }, payload) {
            let [palette] = Object.values(payload);
            let response;
            let customPaletteData = state.cfg.customPalettes
                ? library.cloneObj(state.cfg.customPalettes)
                : [];
            let existingPalette = customPaletteData.find((iPalette) => palette.id === iPalette.id);
            let formattedPalette;
            if (!existingPalette) {
                let paletteId = palette.id !== 'newPalette' && palette.id;
                if (!paletteId) paletteId = 'palette_' + library.getUniqueID();
                formattedPalette = {
                    id: paletteId,
                    title: library.titleCase(palette.title),
                    colors: palette.colors,
                    pId: 'customPalettes',
                    standard: false,
                };
                customPaletteData.push(formattedPalette);
            }
            response = await sDs.post('ec_setCstProperty', 'palettes', JSON.stringify(customPaletteData));
            if (!existingPalette && response) commit('updatePalettes', ['add', formattedPalette]);
            else if (response) commit('updatePalettes', ['update', existingPalette]);
            return response;
        },
        async deletePalette({ state, commit }, payload) {
            let response = { status: 'failure' }; // default to failure
            if (!Array.isArray(state.cfg.customPalettes) || !state.cfg.customPalettes.length) return response;
            let [paletteObj] = Object.values(payload);
            let customPaletteData = library.cloneObj(state.cfg.customPalettes);
            let currIndex = customPaletteData.findIndex((palette) => palette.id === paletteObj.id);
            if (currIndex === -1) return response;
            customPaletteData.splice(currIndex, 1);
            response = await sDs.post('ec_setCstProperty', 'palettes', JSON.stringify(customPaletteData));
            if (response) commit('updatePalettes', ['delete', paletteObj, currIndex]);
            return response;
        },
        async getCustomPalettes({ state }) {
            if (state.cfg.customPalettes) return { status: 'skipped' };
            let response = await configStore.getData({ kName: 'customPalettes', fName: 'ec_getCstProperty' }, 'palettes');
            if (response.status === 'success' && response.data) {
                state.cfg.customPalettes = response.data;
            }
            return response;
        }
    },
    mutations: {
        updatePalettes(state, payload) {
            let [method, paletteObj, index] = Object.values(payload);
            if (!Array.isArray(state.cfg.customPalettes)) state.cfg.customPalettes = [];
            // mutate state
            if (method === 'add') state.cfg.customPalettes.push(paletteObj);
            else if (method === 'update' && index !== -1) state.cfg.customPalettes.splice(index, 1, paletteObj);
            else if (method === 'delete' && index !== -1) state.cfg.customPalettes.splice(index, 1);
            // Check for parent custom option
            const parentIndex = state.cfg.customPalettes.findIndex((palette) => palette.id === 'customPalettes');
            const hasCustomPalette = state.cfg.customPalettes.find((palette) => palette.pId === 'customPalettes');
            if (!hasCustomPalette && parentIndex > -1) state.cfg.customPalettes.splice(parentIndex, 1);
            else if (hasCustomPalette && parentIndex === -1) {
                let customParentOption = {
                    id: 'customPalettes',
                    title: 'Custom Palettes',
                    hasChild: true,
                    standard: true,
                    expanded: true,
                    selectable: false,
                    htmlAttributes: { 'prevent-select': 'true' },
                };
                state.cfg.customPalettes.unshift(customParentOption);
            }
        },
        updateTime(state, payload) {
            let [dateFormat, timeFormat] = payload;
            let dateTime = moment();
            state.cfg.currentTime = dateTime.format(timeFormat);
            state.cfg.currentTimeWithSeconds = dateTime.format('h:mm:ss A');
            state.cfg.currentDateTime = dateTime.format(dateFormat + ' ' + timeFormat);
            state.cfg.currentDateTimeWithSeconds = dateTime.format(dateFormat + ' h:mm:ss A');
        }
    }
};
store.registerModule("configStore", configStore);
configStore.setCommonDates();
configStore.updateDateTime();
export { configStore };
